<template>
  <div
      :style="`
              --addBtnColor: ${colors.addBtnColor};
              --addBtnColorInv: ${colors.addBtnColorInv}; 
              --iconsColor1: ${colors.iconsColor1}; 
              --iconsColor2: ${colors.iconsColor2}; 
              --secundar: ${colors.secundarColor}; 
              --principal: ${colors.principalColor}; 
              --sideBarBg: ${colors.sideBarBg}; 
              --mainPageBg: ${colors.mainPageBg}; 
              --white: ${whiteColor}; 
            `"
      :class="[
        (activeKeyboard && json.type == 'Kiosk') ? 'order_view withKey' : 'order_view', 
        (json.type != 'Kiosk') ? 'mobile' : 'kiosk',
        'comp_' + json.company_id
      ]"
      @click="detectActivity"
    >
    <div :class="(loader) ? 'loader' : 'loader none'">
      <div class="el-loading-spinner">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>
      </div>
    </div>
    <div v-if="(cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips) && json.type != 'Kiosk'" class="fastTip">
      <button v-if="(cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips)" @click="addOrRemoveTip(1, true)">+ Tips / Bacșiș</button>
    </div>
    <div v-if="!error && !blockKioskFiscalError && banners && banners.length"
      :class="(banners && banners.length && activeProductList.top && json.type != 'Kiosk') ? 'banner bannerHidden' : 'banner'" 
      >
      <swiper
        :modules="swiperModule"
        effect="fade"
        v-if="banners && banners.length"
        scrollbar
        :loop="true"
        :grabCursor="false"
        :centeredSlides="true"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
          waitForTransition: false
        }"
        class="special-offer-block focus-in"
       >
        <swiper-slide
          v-for="(slider, index) in banners"
          :key="index + 'slider'">
          <a @click="redirectFromImage(slider)">
            <div class="banner_img" 
                  :style="'background-image: URL('+slider.image_banner+');'" 
                  :alt="'Special Offer' + index"></div>
          </a>
        </swiper-slide>
      </swiper>
    </div>

    
    <div :class="[
        'orderspos',
        (banners && banners.length && activeProductList.top && json.type != 'Kiosk') ? 'bannerHidden' : (banners && banners.length) ? 'withBanner' : 'noBanner',
        (cart && cart.myCart && cart.myCart.products_count > 0) ? 'withToolbar' : 'noToolbar',
        (cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips) && json.type != 'Kiosk' ? 'withFastTip' : 'noFastTip'
      ]" v-if="!error && !blockKioskFiscalError">

      <div class="productList_wrapper">
      
        <!-- <div class="search_topBar" v-if="json.type != 'Kiosk'">
        </div> -->

        <div :class="[
          (this.json.type != 'Kiosk' && top_category && selectedTopCategory && top_category.filter(el => el.id == selectedTopCategory)  && top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1) ? 'with_filter2' : 'no_filter2',
          'productList_wrapper_left'
        ]">
          <!-- <div class="productList_filter">
            <h3>Categorii</h3>
          </div> -->
          <div class="filter">
            <div class="settingsBtn" v-if="json.type == 'Kiosk' && showSettings" @click="goToSettings">
              <settingsSvg />
            </div>
            <div class="logo_f" v-if="json.type == 'Kiosk'">
              <img :src="companyLogo" alt="logo">
            </div>
            <div :class="['filter__bar',
              // (activeFilter.top) ? 'activeTop' : '',
              // (activeFilter.bottom) ? 'activeBottom' : ''
            ]">
              <span v-if="json.type !== 'Kiosk'" class="arrow arrow_left" @click="goNextOrPriv(-1)">&lt;</span>
              <div class="filter__cat">
                <template v-for="top in top_category" :key="top.id">
                  <div :class="[
                        ((top.id == selectedTopCategory && this.json.type == 'Kiosk') ? 'topGroup active' : 'topGroup'), 
                        top.id + ' ' //for scroolTopCategory() function
                        ]">
                    <a @click="getTop(top)" :class="(top.id == selectedTopCategory) ? 'selected ' + top.id : '' + top.id ">
                        <div class="cat_photo" :style="'background-image: url('+top.image+');'" ></div>
                        <p>{{getTopCategoryName(top)}}</p>
                    </a>
                    <!-- <div class="childs" v-if="this.json.type == 'Kiosk'">
                      <template v-for="cat in top.categories" :key="cat.id">
                        <a @click="getProducts(cat.id, top.id)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                          <div class="cat_photo" :style="'background-image: url('+cat.image+');'" ></div>
                          <p>{{cat.name}}</p>
                        </a>
                      </template>
                    </div> -->
                  </div>
                </template>
                <template v-for="cat in category" :key="cat.id">
                  <a @click="getProducts(cat.id, null)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                    <div class="cat_photo" :style="'background-image: url('+cat.image+');'" ></div>
                    <p>{{getCategoryName(cat)}}</p>
                  </a>
                </template>
              </div>
              <span v-if="json.type !== 'Kiosk'" class="arrow arrow_right" @click="goNextOrPriv(1)">&gt;</span>
            </div>
          </div>
        </div>

        <div :class="[
          (this.json.type != 'Kiosk' && top_category && selectedTopCategory && this.top_category.filter(el => el.id == selectedTopCategory) && this.top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1) ? 'with_filter2' : 'no_filter2',
          'productList_wrapper_right'
          ]">
          <div class="topBar" v-if="json.type == 'Kiosk'">
            <div class="topBar__left">
              <div class="topBar__back" @click="goBackToPickMethod()">
                <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                  <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                </svg>
              </div>
              <div class="topBar__title">
                <span><b>{{$t('addOrder.'+packingMethod+'_first')}}</b> {{$t('addOrder.'+packingMethod+'_second')}}</span>
              </div>
            </div>
            <div :class="(listOfLangIsOpen) ? 'lang_btn open' : 'lang_btn' ">
              <a @click.prevent="openListOfLang()">
                <img :src="languageFlag(curentLang)" alt="Selected language">
              </a>
              <div class="listOfLang">
                <template v-for="lng in allLang" :key="lng">
                  <a @click.prevent="changeLanguageLocal(lng)" v-if="lng != curentLang">
                    <img :src="languageFlag(lng)" :alt="lng">
                  </a>
                </template>
              </div>
            </div>
          </div>
          <div class="search_topBar" v-if="json.type == 'Kiosk'">
            <!-- <h3>Produse</h3> -->
            <div class="search_wrapper">
              <div class="filter__search showw">
                <div class="search">
                  <span class="icosearch">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29.414" height="29.414" viewBox="0 0 29.414 29.414">
                      <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-3.5 -3.5)">
                        <path id="Path_2498" data-name="Path 2498" d="M28.5,16.5a12,12,0,1,1-12-12A12,12,0,0,1,28.5,16.5Z" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path id="Path_2499" data-name="Path 2499" d="M31.5,31.5l-6.525-6.525" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      </g>
                    </svg>
                  </span>
                  <input type="text" ref="searchText" @click="clearKeyBoard(); activeKeyboard = true" :placeholder="$t('addOrder.search')" v-model="searchText">
                  <span :class="showRemoveTextFromSearch ? 'closeSearch show' : 'closeSearch' " @click="deleteTextFromSearch()">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 460.775 460.775" style="enable-background:new 0 0 460.775 460.775;" xml:space="preserve">
                      <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                        c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                        c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                        c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                        l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                        c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- v-hammer:swipe.left="onSwipeTop" -->
          <!-- v-hm:swipe="onSwipeTop" -->
          <div :class="['productList__wrapper',
              // (activeProductList.top) ? 'activeTop' : '',
              // (activeProductList.bottom) ? 'activeBottom' : ''
          ]">
            <div class="filter" v-if="selectedTopCategory && this.json.type == 'Kiosk'">
              <div class="filter__bar">
                <div class="childs">
                  <template v-for="top in top_category" :key="top.id">
                    <template v-if="top.id == selectedTopCategory">
                      <template v-for="cat in top.categories" :key="cat.id">
                        <a @click="getProducts(cat.id, top.id)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id">
                          <!-- <div class="cat_photo" :style="'background-image: url('+cat.image+');'"></div> -->
                          <p>{{getCategoryName(cat)}}</p>
                        </a>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <div class="product-container">
              <div class="productList" :style="(loading ? 'overflow: hidden;' : '')">
                <template v-if="products && products.length > 0">
                  <template v-for="product in products" :key="product.id">
                    <div
                        :class="[
                          'product',
                          product.is_highlight ? 'is_highlight' : '',
                          (productHasNoStock(product.id) || productIsIndisponible(product.id)) ? 'prodOutOfStock' : ''
                        ]"
                        :ref="'product' + product.id"
                        @click="openProduct(product)"
                      >
                      <template v-if="productHasNoStock(product.id)">
                        <div class="outOfStock"></div>
                        <span class="outOfStockTxt">{{$t('addOrder.outOfStock')}}</span>
                      </template>
                      <template v-else-if="productIsIndisponible(product.id)">
                        <div class="outOfStock"></div>
                        <span class="outOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                      </template>
                      <div class="product_img_title">
                        <div class="productImage__wrapper">
                          <template v-if="product.image_url">
                            <div class="productImage" 
                                :style="['background-image: url(' + encodeURI(resizeProdImage(product.image_src_resize, 250)) + ');',
                                product.image_size ? 'background-size: '+ product.image_size + ';' : '']"></div>
                          </template>
                          <!-- <div class="rectangle"></div> -->
                        </div>
                        <p class="prod_title">{{getProductName(product)}}</p>
                        <template v-if="product.prod_info && product.prod_info != '' && product.prod_info != '<br>'">
                          <p class="showInfo" @click.stop="openInfoPopup(product)">info. nutriționale</p>
                        </template>
                        <template v-if="product.use_price_to_show && product.price_to_show > 0">
                          <p class="prod_price" v-html="product.price_to_show + ' ' + product.price_details.currency_symbol"></p>
                        </template>
                        <template v-else>
                          <template v-if="json.company_id != 46">
                            <p class="discount_badge" v-if="product.old_price > 0">{{Math.ceil(( product.old_price - getProductPrice(product) ) / product.old_price * 100)}} %</p>
                          </template>
                          <p class="old_prod_price" v-if="product.old_price > 0" v-html="product.old_price + ' ' + product.price_details.currency_symbol"></p>
                          <p v-if="!(getProductPrice(product) <= 0) && getProductPrice(product) != '0'" class="prod_price" v-html="getProductPrice(product, true)"></p>
                          <!-- <p @click.stop="addProductDirectlyToCart(product)" class="prod_addDirectToCart" v-if="json.company_id == 39">+</p> -->
                        </template>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <p class="no-products-message">{{$t('addOrder.noProductsMessage')}}</p>
                </template>
                <div :class="(loading ? 'show-loader' : 'hide-loader')">
                  <div class="el-loading-spinner">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="json.type == 'Kiosk' && withNoSwipe" :class="(!activeProductList.bottom && infoShown.bottom && !infoShown.permanentDisabled) ? 'swipeUpForMore show' : 'swipeUpForMore'">
              <svg width="48" height="48" id="e8kfnqc1eafg1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="32.700000 -158 615.300000 615.300000" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
                <g style="animation: e8kfnqc1eafg2_to__to 600ms linear infinite alternate forwards" transform="translate(446.900000,-31.675000)">
                  <path id="e8kfnqc1eafg2" d="M440.700000,-31.700000L475.800000,-66.800000C480,-71,480,-77.700000,475.800000,-81.900000C471.600000,-86.100000,464.900000,-86.100000,460.700000,-81.900000L418,-39.200000C413.800000,-35,413.800000,-28.300000,418,-24.100000L460.700000,18.600000C462.800000,20.700000,465.500000,21.700000,468.300000,21.700000C471,21.700000,473.800000,20.700000,475.800000,18.600000C480,14.400000,480,7.700000,475.800000,3.500000L440.700000,-31.700000Z" transform="translate(-446.900000,31.675000)" fill="inherit" stroke="none" stroke-width="1" />
                </g>
                <g style="animation: e8kfnqc1eafg3_tr__tr 600ms linear infinite alternate forwards" transform="translate(422.274148,395) rotate(0)">
                  <path d="M521.700000,117.700000C512.900000,117.700000,504.800000,120.400000,498,124.900000C492.200000,108.300000,476.300000,96.400000,457.700000,96.400000C448.900000,96.400000,440.800000,99.100000,434,103.600000C428.100000,86.900000,412.200000,75,393.700000,75C385.900000,75,378.600000,77.100000,372.400000,80.700000L372.400000,11C372.400000,-12.500000,353.300000,-31.700000,329.700000,-31.700000C306.100000,-31.700000,287,-12.500000,287,11L287,192.300000L249.900000,164.500000C227.900000,148,196.700000,150.200000,177.200000,169.700000C164.700000,182.200000,164.700000,202.500000,177.200000,214.900000L329.100000,366.800000C347.200000,385,371.400000,395,397,395L447,395C511.700000,395,564.300000,342.400000,564.300000,277.700000L564.300000,160.300000C564.300000,136.800000,545.200000,117.700000,521.700000,117.700000ZM543,277.700000C543,330.600000,499.900000,373.700000,447,373.700000L397,373.700000C377,373.700000,358.300000,365.900000,344.200000,351.800000L192.300000,199.900000C188.100000,195.700000,188.100000,189,192.300000,184.800000C198.900000,178.200000,207.700000,174.800000,216.600000,174.800000C223.800000,174.800000,231.100000,177,237.100000,181.600000L291.200000,222.200000C294.400000,224.600000,298.800000,225,302.400000,223.200000C306,221.400000,308.300000,217.700000,308.300000,213.700000L308.300000,11C308.300000,-0.800000,317.900000,-10.300000,329.600000,-10.300000C341.300000,-10.300000,351,-0.800000,351,11L351,171C351,176.900000,355.800000,181.700000,361.700000,181.700000C367.600000,181.700000,372.400000,176.900000,372.400000,171L372.400000,117.700000C372.400000,105.900000,382,96.400000,393.700000,96.400000C405.400000,96.400000,415,106,415,117.700000L415,171C415,176.900000,419.800000,181.700000,425.700000,181.700000C431.600000,181.700000,436.400000,176.900000,436.400000,171L436.400000,139C436.400000,127.200000,446,117.700000,457.700000,117.700000C469.400000,117.700000,479,127.200000,479,139L479,171C479,176.900000,483.800000,181.700000,489.700000,181.700000C495.600000,181.700000,500.400000,176.900000,500.400000,171L500.400000,160.300000C500.400000,148.500000,510,139,521.700000,139C533.500000,139,543,148.600000,543,160.300000L543,277.700000L543,277.700000Z" transform="translate(-422.274148,-395)" fill="inherit" stroke="none" stroke-width="1" />
                </g>
                <circle id="e8kfnqc1eafg4" r="10.700000" transform="matrix(1 0 0 1 553.70000000000005 -31.70000000000000)" fill="inherit" stroke="none" stroke-width="1" />
                <g style="animation: e8kfnqc1eafg5_ts__ts 600ms linear infinite alternate forwards" transform="translate(553.700000,-31.700000) scale(1,1)">
                  <rect id="e8kfnqc1eafg5" width="122" height="21.300000" rx="0" ry="0" transform="translate(-122,-10.600000)" fill="inherit" stroke="none" stroke-width="1" />
                </g>
              </svg>
              <span>{{$t('addOrder.swipeUpTooltip')}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="toolbar" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && !error && !blockKioskFiscalError">
      <div class="top__toolbar">
          <div class="left__toolbar">
            <div class="cart_btn" @click="showCart()">
              <div class="cart__toolbar" >
                <svg xmlns="http://www.w3.org/2000/svg" width="49.288" height="49.275" viewBox="0 0 49.288 49.275">
                  <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(3 3)">
                    <g id="Bag">
                      <path id="Path_33955" d="M31.613,33.054H11.64C4.3,33.054-1.326,30.56.273,20.525l1.862-13.6C3.12,1.916,6.515,0,9.493,0H33.847c3.022,0,6.22,2.061,7.359,6.924l1.862,13.6C44.425,29.427,38.95,33.054,31.613,33.054Z" transform="translate(0 10.221)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                      <path id="Path_33956" d="M20.718,9.727C20.718,4.355,16.09,0,10.381,0h0A10.68,10.68,0,0,0,3.043,2.834,9.446,9.446,0,0,0,0,9.727H0" transform="translate(11.224 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                      <path id="Line_192" d="M.544.458H.435" transform="translate(28.156 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                      <path id="Line_193" d="M.544.458H.435" transform="translate(14.205 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    </g>
                  </g>
                </svg>
                <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
                  <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
                </template>
              </div>
              <span>{{$t('addOrder.cartBtn')}}</span>
            </div>
            <!-- <div class="total__toolbar">
              <template v-if="cart && cart.myCart && cart.myCart.products_count > 0 && cart.use_coupon_discount && cart.coupon_discount_value <= 0">
                <button v-if="cart.use_coupon_discount && cart.coupon_discount_value <= 0" @click="showCoupon(true)">{{$t('addOrder.couponBtn2')}}</button>
                <button v-if="cart.use_coupon_discount && cart.coupon_discount_value > 0" @click="showCoupon(true)">{{$t('addOrder.removeCoupon')}}</button>
              </template>
            </div> -->
          </div>
          <div class="right__toolbar">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <button class="right__toolbar__tot">
                <span>{{$t('addOrder.total')}}</span>
                <span v-html="cart.myCart.total_cart_price + ' ' + currency_symbol"></span>
              </button>
              <button class="right__toolbar__pay" @click='payNew()' :disabled="cart.myCart.products_count <= 0">{{$t('addOrder.orderNow')}}</button>
            </template>
          </div>
      </div>
    </div>

    <div class="error error_page no_internet_page" v-if="noInternet">
      <h1 class="jumping">{{$t('general.no_internet_kiosk')}}</h1>
      <button class="reload_btn" @click="reloadKiosk">{{$t('general.reload')}}</button>
    </div>

    <div class="error error_page" v-if="error">
      <h1 v-if="json.type == 'Kiosk'" class="jumping">{{$t('general.error_not_open_kiosk')}}</h1>
      <h1 v-else>
        <template v-if="errorType" class="jumping">
          {{$t('general.error_not_open_table_'+ errorType)}}
        </template>
        <template v-else>
          {{$t('general.error_not_open_table')}}
        </template>
      </h1>
      <div class="settingsBtn" v-if="json.type == 'Kiosk' && showSettings" @click="goToSettings">
        <settingsSvg />
      </div>
    </div>

    <!-- settingsModal is z-index 9999 -->
    <div class="error error_page fiscal_error" style="z-index: 1099;" v-if="blockKioskFiscalError">
      <h1 class="jumping">{{$t('general.error_fiscal_kiosk')}}</h1>
      <p class="fiscal_error_info" v-if="fiscalErrorInfo">{{ fiscalErrorInfo }}</p>
      <div class="settingsBtn" v-if="json.type == 'Kiosk' && showSettings" @click="goToSettings">
        <settingsSvg />
      </div>
    </div>

    <vue-final-modal
            name="productModal"
            v-model="showProductModal"
            :hideOverlay="true"
            :class="['productModal', showProductModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <!-- <div class="xModalBtn" @click="showProductModal = false"><span>x</span></div> -->
        <template v-if="currentProductInPopup && currentProductInPopup.image_url">
          <span style=""></span>
          <div class="photo" 
              :style="['background-image: url('+ encodeURI( resizeProdImage(currentProductInPopup.image_src_resize, 1080) ) +');', 
                      currentProductInPopup.image_size ? 'background-size: '+ currentProductInPopup.image_size + ';' : '']">
          </div>
        </template>
        <div class="prod_white" style="background: #fff; position: relative; z-index: 2;">
          <div class="productModal__product" v-if="currentProductInPopup">
            <div class="title__wraper">
              <div class="title">
                <p>{{getProductName(currentProductInPopup)}}</p>
                <template v-if="currentProductInPopup.use_price_to_show && currentProductInPopup.price_to_show > 0">
                  <p v-html="currentProductInPopup.price_to_show + ' ' + currentProductInPopup.price_details.currency_symbol"></p>
                </template>
                <template v-else>
                  <p v-if="getProductPrice(currentProductInPopup)" v-html="getProductPrice(currentProductInPopup, true)"></p>
                </template>
              </div>
              <div class="product_stock" v-if="this.getProductStock(currentProductInPopup.id) >= 1">
                <span class="product_stock_available" v-if="this.getProductStock(currentProductInPopup.id) > 99">{{$t('addOrder.sufficientStock')}}</span>
                <span class="product_stock_available" v-else>{{this.getProductStock(currentProductInPopup.id)}} {{$t('addOrder.available')}}</span>
              </div>
              <div>
                <!-- <template v-if="currentProductInPopup.description && currentProductInPopup.description.length > 455">
                  <p v-html="currentProductInPopup.description_html.substring(0, 455) + '...'"></p>
                </template>
                <template v-else> -->
                  <p v-html="getProductDesc(currentProductInPopup, true)"></p>
                <!-- </template> -->
              </div>
            </div>
          </div>

          <div class="gray__prod_wrapper">
            <ProductOptionsKiosk 
            v-if="!optionsInSteps && currentProductInPopup && currentProductInPopup.product_options && currentProductInPopup.product_options.length"
            :currentProductInPopup="currentProductInPopup"
            :stocks-for-product-options="stocksForProductOptions"
            :product-options-cov-stock-map="productOptionsCovStockMap"
            @update-categories="updateCategories"
            @call-from-options="callFromOptions"
            ></ProductOptionsKiosk>

            <div class="info__wrapper" id="prodInfoWrapper" v-if="currentProductInPopup && currentProductInPopup.allow_user_comments">
              <textarea name="info" maxlength="255" :placeholder="$t('addOrder.infosup')" @click="activeKeyboard = true; scrollToId('prodInfoWrapper', '.productModal__wrapper')" v-model="currentProductInPopup.additional_info"></textarea>
            </div>

            <div class="other_info" v-if="currentProductInPopup && currentProductInPopup.other_info.length">
                <div class="info" v-for="other_info in currentProductInPopup.other_info" :key="other_info.id" @click="(isExpended == other_info.id) ? isExpended = null : isExpended = other_info.id">
                  <h2>{{other_info.title}}</h2>
                  <div class="other_info_ico">
                    <svg :class="(isExpended != other_info.id) ? 'closed' : ''" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 460.775 460.775" style="enable-background:new 0 0 460.775 460.775;" xml:space="preserve">
                          <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                            c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                            c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                            c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                            l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                            c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                    </svg>
                  </div>
                  <Collapse as="section" :when="isExpended == other_info.id" class="collapse_class">
                    <div class="description">
                      <p v-html="other_info.description"></p>
                    </div>
                  </Collapse>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="backBar" v-if="currentProductInPopup && !currentProductInPopup.limit_quantity_kiosk_qr">
        <div class="footer__quantity">
          <button :disabled="currentProductInPopup.quantity <= 1" @click="updateQuantity(currentProductInPopup, 0)">-</button>
          <span>{{currentProductInPopup.quantity}}</span>
          <button @click="updateQuantity(currentProductInPopup, 1)"
          :disabled="!canIncreaseProductQuantity(currentProductInPopup)"
          >+</button>
        </div>
      </div>
      <div class="footer" v-if="currentProductInPopup">

        <div class="footer__backbtn">
          <button class="backButon" @click="showProductModal = false">
            <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                  <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                </svg>
            {{$t('addOrder.back')}}
          </button>
        </div>

        <div class="footer__right">
          <template v-if="currentProductInPopup.in_edit || !productHasNoStock(currentProductInPopup.id)">
            <div class="footer__price">
              <span>{{$t('addOrder.total')}}</span>
              <span v-html="getProductPrice(currentProductInPopup, true)"></span>
            </div>
            <div class="footer__addToCart">
              <template v-if="optionsInSteps">
                <button @click="nextOptionToCart(1,1)">
                  {{$t('addOrder.next_to_option')}}
                  <svg fill="#000000" style="margin-left: 10px; width: 40px; height: 40px;" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                     width="800px" height="800px" viewBox="0 0 414.287 414.287"
                     xml:space="preserve">
                    <g>
                      <path d="M412.398,202.993L288.535,95.289c-1.502-1.305-3.591-1.699-5.463-1.027c-1.873,0.67-3.237,2.3-3.568,4.261l-8.938,52.887
                        H40.554c-2.684,0-4.976,1.938-5.423,4.583l-3.054,18.067c-0.27,1.597,0.177,3.23,1.223,4.467c1.045,1.237,2.581,1.95,4.2,1.95
                        h103.982l-2.208,15H8.134c-2.684,0-4.976,1.938-5.423,4.583l-2.634,15.584c-0.27,1.597,0.177,3.229,1.223,4.467
                        c1.045,1.236,2.581,1.949,4.2,1.949h159.196l-2.206,15H63.505c-2.684,0-4.976,1.938-5.423,4.583l-2.505,14.817
                        c-0.271,1.597,0.177,3.229,1.222,4.467c1.046,1.237,2.582,1.95,4.201,1.95h190.721l-8.628,51.053
                        c-0.366,2.168,0.593,4.346,2.439,5.538c0.908,0.586,1.945,0.879,2.982,0.879c1.07,0,2.141-0.312,3.067-0.935l160.272-107.704
                        c1.421-0.955,2.316-2.518,2.422-4.225C414.385,205.776,413.689,204.116,412.398,202.993z"/>
                    </g>
                  </svg>
                </button>
              </template>
              <template v-else>
                <template v-if="currentProductInPopup.in_edit">
                  <button :disabled="addToCartDisabled" @click="editToCart()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="50.942" height="50.933" viewBox="0 0 50.942 50.933">
                      <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(1.999 2)">
                        <g id="Bag">
                          <path id="Path_33955" d="M34.286,35.848H12.624C4.667,35.848-1.438,33.144.3,22.26L2.315,7.509C3.384,2.078,7.066,0,10.3,0H36.708c3.278,0,6.746,2.235,7.981,7.509l2.019,14.75C48.181,31.915,42.243,35.848,34.286,35.848Z" transform="translate(0 11.085)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                          <path id="Path_33956" d="M22.47,10.549C22.47,4.723,17.45,0,11.259,0h0A11.582,11.582,0,0,0,3.3,3.074,10.244,10.244,0,0,0,0,10.549H0" transform="translate(12.172 0)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                          <path id="Line_192" d="M.554.458H.435" transform="translate(30.573 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                          <path id="Line_193" d="M.554.458H.435" transform="translate(15.443 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        </g>
                      </g>
                    </svg>
                  {{$t('addOrder.edit')}}</button>
                </template>
                <template v-else>
                  <button :disabled="addToCartDisabled" @click="addToCart()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="50.942" height="50.933" viewBox="0 0 50.942 50.933">
                      <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(1.999 2)">
                        <g id="Bag">
                          <path id="Path_33955" d="M34.286,35.848H12.624C4.667,35.848-1.438,33.144.3,22.26L2.315,7.509C3.384,2.078,7.066,0,10.3,0H36.708c3.278,0,6.746,2.235,7.981,7.509l2.019,14.75C48.181,31.915,42.243,35.848,34.286,35.848Z" transform="translate(0 11.085)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                          <path id="Path_33956" d="M22.47,10.549C22.47,4.723,17.45,0,11.259,0h0A11.582,11.582,0,0,0,3.3,3.074,10.244,10.244,0,0,0,0,10.549H0" transform="translate(12.172 0)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                          <path id="Line_192" d="M.554.458H.435" transform="translate(30.573 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                          <path id="Line_193" d="M.554.458H.435" transform="translate(15.443 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        </g>
                      </g>
                    </svg>
                  {{$t('addOrder.add')}}</button>
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="footerOutOfStock">
              <span class="footerOutOfStockTxt">{{$t('addOrder.outOfStock')}}</span>
            </div>
          </template>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="infoProdModal"
            v-model="showInfoProdModal"
            :hideOverlay="true"
            :class="['infoProdModal', showInfoProdModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <!-- <div class="xModalBtn" @click="showProductModal = false"><span>x</span></div> -->
        <template v-if="currentProductInInfoPopup && currentProductInInfoPopup.image_src">
          <span style=""></span>
          <div class="photo" 
              :style="['background-image: url('+ encodeURI(currentProductInInfoPopup.image_src) +');', 
                      currentProductInInfoPopup.image_size ? 'background-size: '+ currentProductInInfoPopup.image_size + ';' : '']">
          </div>
        </template>
        <div class="prod_white" style="background: #fff; position: relative; z-index: 2;">
          
          <div class="productModal__product" v-if="currentProductInInfoPopup">
            <div class="title__wraper">
              <div class="title">
                <p>{{getProductName(currentProductInInfoPopup)}}</p>
                <p></p>
              </div>
              <div>
                
                <p v-html="currentProductInInfoPopup.prod_info"></p>

              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="footer" v-if="currentProductInInfoPopup">
        <div class="footer__backbtn">
          <button class="backButon" @click="closeInfoPopup()">
            <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                  <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                </svg>
            {{$t('addOrder.back')}}
          </button>
        </div>

        <div class="footer__right">
          <div class="footer__addToCart">
            <button @click="openProduct(currentProductInInfoPopup)">
              <svg xmlns="http://www.w3.org/2000/svg" width="50.942" height="50.933" viewBox="0 0 50.942 50.933">
                <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(1.999 2)">
                  <g id="Bag">
                    <path id="Path_33955" d="M34.286,35.848H12.624C4.667,35.848-1.438,33.144.3,22.26L2.315,7.509C3.384,2.078,7.066,0,10.3,0H36.708c3.278,0,6.746,2.235,7.981,7.509l2.019,14.75C48.181,31.915,42.243,35.848,34.286,35.848Z" transform="translate(0 11.085)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                    <path id="Path_33956" d="M22.47,10.549C22.47,4.723,17.45,0,11.259,0h0A11.582,11.582,0,0,0,3.3,3.074,10.244,10.244,0,0,0,0,10.549H0" transform="translate(12.172 0)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                    <path id="Line_192" d="M.554.458H.435" transform="translate(30.573 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                    <path id="Line_193" d="M.554.458H.435" transform="translate(15.443 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                  </g>
                </g>
              </svg>
            {{$t('addOrder.add')}}</button>
          </div>
        </div>
      </div>
    </vue-final-modal>    
    <vue-final-modal
            name="infoProdModal"
            v-model="showInfoOptModal"
            :hideOverlay="true"
            :class="['infoProdModal', showInfoOptModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <!-- <div class="xModalBtn" @click="showProductModal = false"><span>x</span></div> -->
        <template v-if="currentOptInInfoPopup && currentOptInInfoPopup.image">
          <span style=""></span>
          <div class="photo" 
              :style="['background-image: url('+ encodeURI(currentOptInInfoPopup.image) +');', 
                      currentOptInInfoPopup.image_size ? 'background-size: '+ currentOptInInfoPopup.image_size + ';' : '']">
          </div>
        </template>
        <div class="prod_white" style="background: #fff; position: relative; z-index: 2;">
          
          <div class="productModal__product" v-if="currentOptInInfoPopup">
            <div class="title__wraper">
              <div class="title">
                <p>{{currentOptInInfoPopup.name}}</p>
                <p></p>
              </div>
              <div>
                
                <p v-html="currentOptInInfoPopup.company_option_value.cov_info"></p>

              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="footer" v-if="currentOptInInfoPopup">
        <div class="footer__backbtn">
          <button class="backButon" @click="closeInfoPopupForOption()">
            <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                  <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                </svg>
            {{$t('addOrder.back')}}
          </button>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="optionModal"
            v-model="showOptionModal"
            :hideOverlay="true"
            :class="['optionModal', showOptionModal ? 'active' : '', showOptionModalEffectOut ? 'out' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <!-- <div class="xModalBtn" @click="showOptionModal = false"><span>x</span></div> -->
        <template v-if="currentOptionInPopup && currentOptionInPopup.company_option && currentOptionInPopup.company_option.image">
          <span style=""></span>
          <template v-if="currentOptionInPopup.image.includes('/placeholder.')">
            <!-- <div class="photo" :style="'background-image: url('+companyLogo+');'"></div> -->

            <template v-if="currentProductInPopup && currentProductInPopup.image_url && currentProductInPopup.image_url[0]['url']">
              <div class="photo" 
                  :style="['background-image: url('+currentProductInPopup.image_url[0]['url']+');', 
                          currentProductInPopup.image_size ? 'background-size: '+ currentProductInPopup.image_size + ';' : '']">
              </div>
            </template>

          </template>
          <template v-else>
            <div class="photo" :style="'background-image: url('+currentOptionInPopup.image+');'"></div>
          </template>
        </template>
        <div class="prod_white" style="background: #fff; position: relative; z-index: 2;">
          <!-- <div class="productModal__product" v-if="currentOptionInPopup">
            <div class="title__wraper">
              <div class="title">
                <p>{{currentOptionInPopup.name}}</p>
              </div>
              <div class="minMax" v-if="currentOptionInPopup.type == 'radio' && currentOptionInPopup.values.length > 1 && currentOptionInPopup.required">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                    <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#acacac" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <div>
                    <span>{{$t('addOrder.selectMinMax')}}</span> 
                    <span>{{$t('addOrder.selectMin')}} 1</span> 
                  </div>
              </div>
              <div class="minMax" v-if="currentOptionInPopup.min_no || currentOptionInPopup.max_no">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                    <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#acacac" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <div>
                    <span>{{$t('addOrder.selectMinMax')}}</span> 
                    <span v-if="currentOptionInPopup.min_no">{{$t('addOrder.selectMin')}} {{currentOptionInPopup.min_no}}</span> 
                    <span v-if="currentOptionInPopup.max_no">{{$t('addOrder.selectMax')}} {{currentOptionInPopup.max_no}}</span>
                  </div>
              </div>
            </div>
          </div> -->

          <div class="options__wrapper" v-if="currentOptionInPopup">
            <div class="option">
              <!-- v-if="option.show_type_kiosk != 'steps'" -->
              <div class="options">
                <div class="option_title">
                  <div class="title">
                    <p>{{currentOptionInPopup.name}}</p>
                  </div>
                  <div class="minMax" v-if="currentOptionInPopup.type == 'radio' && currentOptionInPopup.values.length > 1 && currentOptionInPopup.required">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                        <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#acacac" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      </svg>
                      <div>
                        <span>{{$t('addOrder.selectMinMax')}}</span> 
                        <span>{{$t('addOrder.selectMin')}} 1</span> 
                      </div>
                  </div>
                  <div class="minMax" v-if="currentOptionInPopup.min_no || currentOptionInPopup.max_no">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                        <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#acacac" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      </svg>
                      <div>
                        <span>{{$t('addOrder.selectMinMax')}}</span> 
                        <span v-if="currentOptionInPopup.min_no">{{$t('addOrder.selectMin')}} {{currentOptionInPopup.min_no}}</span> 
                        <span v-if="currentOptionInPopup.max_no">{{$t('addOrder.selectMax')}} {{currentOptionInPopup.max_no}}</span>
                      </div>
                  </div>
                </div>
                <template v-for="(values, keyVal) in currentOptionInPopup.values" :key="values.id">
                  <div 
                      @click="clickOnRef('ref_' + values.id)" 
                      :class="['option_value', 
                                values.checked ? 'active' : '', 
                                values.disabled && currentOptionInPopup.type === 'checkbox' ? 'disabled' : ''
                              ]"
                    >
                    <template v-if="currentOptionInPopup.values[keyVal].image.includes('/placeholder.')">
                      <div class="opt_photo" :style="'background-image: url('+companyLogo+');'" ></div>
                    </template>
                    <template v-else>
                      <div class="opt_photo" :style="'background-image: url('+currentOptionInPopup.values[keyVal].image+');'" ></div>
                    </template>
                    <span class="val_name">{{values.name}}</span>
                    <span v-if="getOptionValueStock(optionValueStockProductId(values)) >= 1" class="option_stock_badge">
                      <template v-if="getOptionValueStock(optionValueStockProductId(values)) > 99">{{$t('addOrder.sufficientStock')}}</template>
                      <template v-else>{{getOptionValueStock(optionValueStockProductId(values))}} {{$t('addOrder.available')}}</template>
                    </span>

                    <template v-if="!currentOptionInPopup.hide_prices">
                      <span v-if="values.price > 0" class="val_price" v-html="'+ ' + (values.price * (values.quantity || 1)) + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                    </template>

                    <!-- Quantity Selector - Only for checkbox with allow_quantity -->
                    <template v-if="currentOptionInPopup.type === 'checkbox' && values.company_option_value && values.company_option_value.allow_quantity && values.checked">
                      <div class="quantity-wrapper" @click.stop>
                        <quantity-selector
                          :value="values.quantity || 1"
                          :min="values.company_option_value.min_quantity || 1"
                          :max="getOptionValueMaxQuantity(currentOptionInPopup, values)"
                          @change="updateQuantityOptions(currentOptionInPopup.id, values, $event)"
                        />
                      </div>
                    </template>

                    <label :for="values.id">
                      <template v-if="(currentOptionInPopup.type === 'checkbox')">
                        <input :type="currentOptionInPopup.type"
                            :ref="'ref_' + values.id"
                            :name="currentOptionInPopup.id"
                            :disabled="values.disabled"
                            :value="values.id"
                            :id="values.id"
                            @change="updateCategories(currentOptionInPopup.id, values.id)"
                            v-model="values.checked"
                        >
                      </template>
                      <template v-else>
                        <input :type="currentOptionInPopup.type"
                            :ref="'ref_' + values.id"
                            :name="currentOptionInPopup.id"
                            :value="values.id"
                            :id="values.id"
                            @change="updateCategories(currentOptionInPopup.id, values.id)"
                            v-model="currentOptionInPopup.checked"
                        >
                      </template>
                    </label>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="footer" v-if="currentProductInPopup">
        <div class="footer__left" style="height: 100%;">
          <div class="footer__addToCart">
            <button @click="nextOptionToCart(-1)">
              <svg fill="#000000" style="margin-right: 10px; width: 40px; height: 40px;-webkit-transform: scaleX(-1); transform: scaleX(-1);" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                 width="800px" height="800px" viewBox="0 0 414.287 414.287"
                 xml:space="preserve">
                <g>
                  <path d="M412.398,202.993L288.535,95.289c-1.502-1.305-3.591-1.699-5.463-1.027c-1.873,0.67-3.237,2.3-3.568,4.261l-8.938,52.887
                    H40.554c-2.684,0-4.976,1.938-5.423,4.583l-3.054,18.067c-0.27,1.597,0.177,3.23,1.223,4.467c1.045,1.237,2.581,1.95,4.2,1.95
                    h103.982l-2.208,15H8.134c-2.684,0-4.976,1.938-5.423,4.583l-2.634,15.584c-0.27,1.597,0.177,3.229,1.223,4.467
                    c1.045,1.236,2.581,1.949,4.2,1.949h159.196l-2.206,15H63.505c-2.684,0-4.976,1.938-5.423,4.583l-2.505,14.817
                    c-0.271,1.597,0.177,3.229,1.222,4.467c1.046,1.237,2.582,1.95,4.201,1.95h190.721l-8.628,51.053
                    c-0.366,2.168,0.593,4.346,2.439,5.538c0.908,0.586,1.945,0.879,2.982,0.879c1.07,0,2.141-0.312,3.067-0.935l160.272-107.704
                    c1.421-0.955,2.316-2.518,2.422-4.225C414.385,205.776,413.689,204.116,412.398,202.993z"/>
                </g>
              </svg>
              {{$t('addOrder.prev_to_option')}}
            </button>
          </div>
        </div>
        <div class="footer__right">
          <div class="footer__price">
            <span>{{$t('addOrder.total')}}</span>
            <span v-html="getProductPrice(currentProductInPopup, true)"></span>
          </div>
          <div class="footer__addToCart">
            <template v-if="optionsInSteps && currentOptionInPopup && !currentOptionInPopup.is_the_last_option">
              <button @click="nextOptionToCart()" :disabled="verifyIfOptionIsDisabled()">
                {{$t('addOrder.next_to_option')}}
                <svg fill="#000000" style="margin-left: 10px; width: 40px; height: 40px;" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                   width="800px" height="800px" viewBox="0 0 414.287 414.287"
                   xml:space="preserve">
                  <g>
                    <path d="M412.398,202.993L288.535,95.289c-1.502-1.305-3.591-1.699-5.463-1.027c-1.873,0.67-3.237,2.3-3.568,4.261l-8.938,52.887
                      H40.554c-2.684,0-4.976,1.938-5.423,4.583l-3.054,18.067c-0.27,1.597,0.177,3.23,1.223,4.467c1.045,1.237,2.581,1.95,4.2,1.95
                      h103.982l-2.208,15H8.134c-2.684,0-4.976,1.938-5.423,4.583l-2.634,15.584c-0.27,1.597,0.177,3.229,1.223,4.467
                      c1.045,1.236,2.581,1.949,4.2,1.949h159.196l-2.206,15H63.505c-2.684,0-4.976,1.938-5.423,4.583l-2.505,14.817
                      c-0.271,1.597,0.177,3.229,1.222,4.467c1.046,1.237,2.582,1.95,4.201,1.95h190.721l-8.628,51.053
                      c-0.366,2.168,0.593,4.346,2.439,5.538c0.908,0.586,1.945,0.879,2.982,0.879c1.07,0,2.141-0.312,3.067-0.935l160.272-107.704
                      c1.421-0.955,2.316-2.518,2.422-4.225C414.385,205.776,413.689,204.116,412.398,202.993z"/>
                  </g>
                </svg>
              </button>
            </template>
            <template v-else>
              <template v-if="currentProductInPopup.in_edit">
                <button :disabled="addToCartDisabled" @click="editToCart()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="50.942" height="50.933" viewBox="0 0 50.942 50.933">
                    <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(1.999 2)">
                      <g id="Bag">
                        <path id="Path_33955" d="M34.286,35.848H12.624C4.667,35.848-1.438,33.144.3,22.26L2.315,7.509C3.384,2.078,7.066,0,10.3,0H36.708c3.278,0,6.746,2.235,7.981,7.509l2.019,14.75C48.181,31.915,42.243,35.848,34.286,35.848Z" transform="translate(0 11.085)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        <path id="Path_33956" d="M22.47,10.549C22.47,4.723,17.45,0,11.259,0h0A11.582,11.582,0,0,0,3.3,3.074,10.244,10.244,0,0,0,0,10.549H0" transform="translate(12.172 0)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        <path id="Line_192" d="M.554.458H.435" transform="translate(30.573 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        <path id="Line_193" d="M.554.458H.435" transform="translate(15.443 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                      </g>
                    </g>
                  </svg>
                {{$t('addOrder.edit')}}</button>
              </template>
              <template v-else>
                <button :disabled="addToCartDisabled" @click="addToCart()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="50.942" height="50.933" viewBox="0 0 50.942 50.933">
                    <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(1.999 2)">
                      <g id="Bag">
                        <path id="Path_33955" d="M34.286,35.848H12.624C4.667,35.848-1.438,33.144.3,22.26L2.315,7.509C3.384,2.078,7.066,0,10.3,0H36.708c3.278,0,6.746,2.235,7.981,7.509l2.019,14.75C48.181,31.915,42.243,35.848,34.286,35.848Z" transform="translate(0 11.085)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        <path id="Path_33956" d="M22.47,10.549C22.47,4.723,17.45,0,11.259,0h0A11.582,11.582,0,0,0,3.3,3.074,10.244,10.244,0,0,0,0,10.549H0" transform="translate(12.172 0)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        <path id="Line_192" d="M.554.458H.435" transform="translate(30.573 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                        <path id="Line_193" d="M.554.458H.435" transform="translate(15.443 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                      </g>
                    </g>
                  </svg>
                {{$t('addOrder.add')}}</button>
              </template>
            </template>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="cartModal"
            v-model="showCartModal"
            :hideOverlay="true"
            :class="['cartModal', showCartModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="cart__wrapper">
        <!-- <div class="xModalBtn" @click="showCartModal = false"><span>x</span></div> -->
        <div class="cartDetail">
          <div class="cartDetail__head">
            <div class="cartTitle">
              <p>{{$t('addOrder.cartDet')}}</p>
              <span v-if="json.type != 'Kiosk'">{{json.type}} {{json.number}}</span>
            </div>
            <div class="packing_method" v-if="packingMethod">
              <span><b>{{$t('addOrder.'+packingMethod+'_first')}}</b> {{$t('addOrder.'+packingMethod+'_second')}}</span>
            </div>
          </div>
          
          <div class="products" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
            <template v-if="json.type != 'Kiosk' && cart.myCart.hasMultipleFingerprint">
              <template v-for="(prodInThisFinger, this_finger) in cart.myCart.products_sortBy_fingerprint" v-bind:key="prodInThisFinger.fingerprint">
                <div :class="(this_finger == fingerprint) ? 'fgp my' : 'fgp' ">
                  <span class="fingerprint_title">{{this_finger}}</span>
                  <template v-for="prod in prodInThisFinger" v-bind:key="prod.id">
                    <div class="product">
                      <div v-if="productIsIndisponible(prod.id)" class="outOfStockCart"> </div>
                      <div class="product_details_wrapper">
                        <span v-if="productIsIndisponible(prod.id)" class="cartOutOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                        <template v-if="prod.image">
                          <div class="product__photo" :style="'background-image: url(' + prod.image + ');'">
                          </div>
                        </template>
                        
                        <div class="description">
                          <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                          <span class="product__extra" v-if="prod.extra">{{prod.extra}}</span>
                          <!-- <template v-if="prod.extra">
                            <span 
                                v-for="(part, index) in prod.extra.split(',')" 
                                :key="index"
                                class="product__extra"
                            >
                                {{ index === 0 ? part.trim() : part.trim() }}
                            </span>
                          </template> -->
                          <span class="product__additional_info" v-if="prod.additional_info">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                          <span class="product__is_bonus" v-if="prod.is_bonus">{{$t('addOrder.freeProd')}}</span>

                          <div class="product_price" v-if="json.type != 'Kiosk'">
                            <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                          </div>
                        </div>
                        
                        <div class="product_details" v-if="json.type == 'Kiosk'">
                          <div class="product_price">
                            <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                          </div>
                          <div class="product_right">
                            <button class="product__modify" @click="modifyProduct(prod)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="29.61" height="29.61" viewBox="0 0 29.61 29.61">
                                <g id="pencil-square-fill" opacity="0.6">
                                  <path id="Path_104" data-name="Path 104" d="M0,0H29.61V29.61H0Z" fill="rgba(0,0,0,0)"/>
                                  <path id="Path_105" data-name="Path 105" d="M6.935,4A4.935,4.935,0,0,0,2,8.935V21.272a4.935,4.935,0,0,0,4.935,4.935H19.273a4.935,4.935,0,0,0,4.935-4.935V10.712L13.992,20.927a1.234,1.234,0,0,1-.888.345H8.169a1.234,1.234,0,0,1-1.234-1.234V15.1a1.234,1.234,0,0,1,.345-.888L17.5,4Z" transform="translate(0.467 0.935)"/>
                                  <path id="Path_106" data-name="Path 106" d="M17.5,4.468,7.28,14.683a1.234,1.234,0,0,0-.345.888v4.935A1.234,1.234,0,0,0,8.169,21.74H13.1a1.234,1.234,0,0,0,.888-.345L24.207,11.179V21.74a4.935,4.935,0,0,1-4.935,4.935H6.935A4.935,4.935,0,0,1,2,21.74V9.4A4.935,4.935,0,0,1,6.935,4.468ZM23.369,2.16,9.4,16.114v3.158h3.158L26.527,5.294a2.393,2.393,0,0,0,.148-.827,2.332,2.332,0,0,0-.753-1.8A2.467,2.467,0,0,0,24.207,2a2.307,2.307,0,0,0-.839.16Z" transform="translate(0.467 0.467)"/>
                                </g>
                              </svg>
                            {{$t('addOrder.modif')}}</button>
                            <button class="product__delete" @click="deleteProduct(prod.id, prod.index)">x</button>
                            <div class="quantity" v-if="!prod.limit_quantity_kiosk_qr">
                              <button :disabled="prod.quantity <= 1" @click="editToCartUpdateQuantity(prod.quantity-1, prod.id, prod.index)">-</button>
                              <span>{{prod.quantity}}</span>
                              <button @click="editToCartUpdateQuantity(prod.quantity+1, prod.id, prod.index, prod.quantity)" :disabled="verifyProductStockInCart(prod)">+</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="product_details" v-if="json.type != 'Kiosk'">
                        <div class="product_right">
                          <div class="quantity" v-if="!prod.limit_quantity_kiosk_qr">
                            <button :disabled="prod.quantity <= 1" @click="editToCartUpdateQuantity(prod.quantity-1, prod.id, prod.index)">-</button>
                            <span>{{prod.quantity}}</span>
                            <button @click="editToCartUpdateQuantity(prod.quantity+1, prod.id, prod.index, prod.quantity)" :disabled="verifyProductStockInCart(prod)">+</button>
                          </div>
                          <div class="product_right_btns">
                            <button class="product__modify" @click="modifyProduct(prod)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="29.61" height="29.61" viewBox="0 0 29.61 29.61">
                                <g id="pencil-square-fill" opacity="0.6">
                                  <path id="Path_104" data-name="Path 104" d="M0,0H29.61V29.61H0Z" fill="rgba(0,0,0,0)"/>
                                  <path id="Path_105" data-name="Path 105" d="M6.935,4A4.935,4.935,0,0,0,2,8.935V21.272a4.935,4.935,0,0,0,4.935,4.935H19.273a4.935,4.935,0,0,0,4.935-4.935V10.712L13.992,20.927a1.234,1.234,0,0,1-.888.345H8.169a1.234,1.234,0,0,1-1.234-1.234V15.1a1.234,1.234,0,0,1,.345-.888L17.5,4Z" transform="translate(0.467 0.935)"/>
                                  <path id="Path_106" data-name="Path 106" d="M17.5,4.468,7.28,14.683a1.234,1.234,0,0,0-.345.888v4.935A1.234,1.234,0,0,0,8.169,21.74H13.1a1.234,1.234,0,0,0,.888-.345L24.207,11.179V21.74a4.935,4.935,0,0,1-4.935,4.935H6.935A4.935,4.935,0,0,1,2,21.74V9.4A4.935,4.935,0,0,1,6.935,4.468ZM23.369,2.16,9.4,16.114v3.158h3.158L26.527,5.294a2.393,2.393,0,0,0,.148-.827,2.332,2.332,0,0,0-.753-1.8A2.467,2.467,0,0,0,24.207,2a2.307,2.307,0,0,0-.839.16Z" transform="translate(0.467 0.467)"/>
                                </g>
                              </svg>
                            </button>
                            <button class="product__delete" @click="deleteProduct(prod.id, prod.index)">x</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-for="prod in cart.myCart.products" v-bind:key="prod.id">
                <div class="product">
                  <div v-if="prod.out_of_stock" class="outOfStockCart"> </div>
                  <div v-else-if="productIsIndisponible(prod.id)" class="outOfStockCart"> </div>
                  <div class="product_details_wrapper">
                    <span v-if="prod.out_of_stock" class="cartOutOfStockTxt">{{$t('addOrder.outOfStock')}}</span>
                    <span v-else-if="productIsIndisponible(prod.id)" class="cartOutOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                    <template v-if="prod.image">
                      <div class="product__photo" :style="'background-image: url(' + prod.image + ');'">
                      </div>
                    </template>

                    <div class="description">
                      <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                      <!-- <span class="product__extra" v-if="prod.extra">{{prod.extra}}</span> -->
                      <template v-if="prod.extra">
                        <span 
                            v-for="(part, index) in prod.extra.split(',')" 
                            :key="index"
                            class="product__extra"
                        >
                            {{ index === 0 ? part.trim() : part.trim() }}
                        </span>
                      </template>
                      <span class="product__additional_info" v-if="prod.additional_info">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                      <span class="product__is_bonus" v-if="prod.is_bonus">{{$t('addOrder.freeProd')}}</span>

                      <div class="product_price" v-if="json.type != 'Kiosk'">
                        <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                      </div>
                    </div>
                    
                    <div class="product_details" v-if="json.type == 'Kiosk'">
                      <div class="product_price">
                        <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                      </div>
                      <div class="product_right">
                        <button class="product__modify" @click="modifyProduct(prod)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="29.61" height="29.61" viewBox="0 0 29.61 29.61">
                            <g id="pencil-square-fill" opacity="0.6">
                              <path id="Path_104" data-name="Path 104" d="M0,0H29.61V29.61H0Z" fill="rgba(0,0,0,0)"/>
                              <path id="Path_105" data-name="Path 105" d="M6.935,4A4.935,4.935,0,0,0,2,8.935V21.272a4.935,4.935,0,0,0,4.935,4.935H19.273a4.935,4.935,0,0,0,4.935-4.935V10.712L13.992,20.927a1.234,1.234,0,0,1-.888.345H8.169a1.234,1.234,0,0,1-1.234-1.234V15.1a1.234,1.234,0,0,1,.345-.888L17.5,4Z" transform="translate(0.467 0.935)"/>
                              <path id="Path_106" data-name="Path 106" d="M17.5,4.468,7.28,14.683a1.234,1.234,0,0,0-.345.888v4.935A1.234,1.234,0,0,0,8.169,21.74H13.1a1.234,1.234,0,0,0,.888-.345L24.207,11.179V21.74a4.935,4.935,0,0,1-4.935,4.935H6.935A4.935,4.935,0,0,1,2,21.74V9.4A4.935,4.935,0,0,1,6.935,4.468ZM23.369,2.16,9.4,16.114v3.158h3.158L26.527,5.294a2.393,2.393,0,0,0,.148-.827,2.332,2.332,0,0,0-.753-1.8A2.467,2.467,0,0,0,24.207,2a2.307,2.307,0,0,0-.839.16Z" transform="translate(0.467 0.467)"/>
                            </g>
                          </svg>
                        {{$t('addOrder.modif')}}</button>
                        <button class="product__delete" @click="deleteProduct(prod.id, prod.index)">x</button>
                        <!-- <button class="product__delete" @click="deleteProduct(prod.id, prod.index)"> -->
                        <!-- {{$t('addOrder.delete')}} -->
                        <!-- x -->
                        <!-- </button> -->
                        <div class="quantity" v-if="!prod.limit_quantity_kiosk_qr">
                          <button :disabled="prod.quantity <= 1" @click="editToCartUpdateQuantity(prod.quantity-1, prod.id, prod.index, prod.quantity)">-</button>
                          <span>{{prod.quantity}}</span>
                          <button @click="editToCartUpdateQuantity(prod.quantity+1, prod.id, prod.index, prod.quantity)"
                          :disabled="verifyProductStockInCart(prod)"
                          >+</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="product_details" v-if="json.type != 'Kiosk'">
                    <div class="product_right">
                      <div class="quantity" v-if="!prod.limit_quantity_kiosk_qr">
                        <button :disabled="prod.quantity <= 1" @click="editToCartUpdateQuantity(prod.quantity-1, prod.id, prod.index, prod.quantity)">-</button>
                        <span>{{prod.quantity}}</span>
                        <button @click="editToCartUpdateQuantity(prod.quantity+1, prod.id, prod.index, prod.quantity)"
                        :disabled="verifyProductStockInCart(prod)"
                        >+</button>
                      </div>
                      <div class="product_right_btns">
                        <button class="product__modify" @click="modifyProduct(prod)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="29.61" height="29.61" viewBox="0 0 29.61 29.61">
                            <g id="pencil-square-fill" opacity="0.6">
                              <path id="Path_104" data-name="Path 104" d="M0,0H29.61V29.61H0Z" fill="rgba(0,0,0,0)"/>
                              <path id="Path_105" data-name="Path 105" d="M6.935,4A4.935,4.935,0,0,0,2,8.935V21.272a4.935,4.935,0,0,0,4.935,4.935H19.273a4.935,4.935,0,0,0,4.935-4.935V10.712L13.992,20.927a1.234,1.234,0,0,1-.888.345H8.169a1.234,1.234,0,0,1-1.234-1.234V15.1a1.234,1.234,0,0,1,.345-.888L17.5,4Z" transform="translate(0.467 0.935)"/>
                              <path id="Path_106" data-name="Path 106" d="M17.5,4.468,7.28,14.683a1.234,1.234,0,0,0-.345.888v4.935A1.234,1.234,0,0,0,8.169,21.74H13.1a1.234,1.234,0,0,0,.888-.345L24.207,11.179V21.74a4.935,4.935,0,0,1-4.935,4.935H6.935A4.935,4.935,0,0,1,2,21.74V9.4A4.935,4.935,0,0,1,6.935,4.468ZM23.369,2.16,9.4,16.114v3.158h3.158L26.527,5.294a2.393,2.393,0,0,0,.148-.827,2.332,2.332,0,0,0-.753-1.8A2.467,2.467,0,0,0,24.207,2a2.307,2.307,0,0,0-.839.16Z" transform="translate(0.467 0.467)"/>
                            </g>
                          </svg>
                        </button>
                        <button class="product__delete" @click="deleteProduct(prod.id, prod.index)">x</button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            
          </div>
          <div class="no_products_in_cart" v-if="cart && cart.myCart && cart.myCart.products_count <= 0 ">
            <p>{{$t('addOrder.empty')}}</p>
            <div class="middle">
              <svg xmlns="http://www.w3.org/2000/svg" width="49.288" height="49.275" viewBox="0 0 49.288 49.275">
                <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(3 3)">
                  <g id="Bag">
                    <path id="Path_33955" d="M31.613,33.054H11.64C4.3,33.054-1.326,30.56.273,20.525l1.862-13.6C3.12,1.916,6.515,0,9.493,0H33.847c3.022,0,6.22,2.061,7.359,6.924l1.862,13.6C44.425,29.427,38.95,33.054,31.613,33.054Z" transform="translate(0 10.221)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Path_33956" d="M20.718,9.727C20.718,4.355,16.09,0,10.381,0h0A10.68,10.68,0,0,0,3.043,2.834,9.446,9.446,0,0,0,0,9.727H0" transform="translate(11.224 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Line_192" d="M.544.458H.435" transform="translate(28.156 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Line_193" d="M.544.458H.435" transform="translate(14.205 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                  </g>
                </g>
              </svg>
            </div>
            <!-- <button @click="showCartModal = false">{{$t('addOrder.backToMenu')}}</button> -->
          </div>
        
          <div class="pre__footer" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
            <div class="pre__footer__l">
              <button class="emptyCart" v-if="cart && cart.myCart && cart.myCart.products.length" @click="emptyCartWithQuestion()">
                <emptyCartSvg /> {{$t('addOrder.emptyCartBtn')}}
              </button>
              
            </div>
            <div class="pre__footer__r">
              <div class="pre__footer__r__colorbox">
                <template v-for="totalsOptions in cart.order_totals" v-bind:key="totalsOptions.name">
                  <template v-if="totalsOptions.use && totalsOptions.name != 'SGR'">
                    <div class="totalsOptions" v-if="totalsOptions.value != 0">
                      <span>{{ getTotalOptionLabel(totalsOptions.name) }}</span>
                      <span v-html="totalsOptions.value + ' ' + currency_symbol"></span>
                    </div>
                  </template>
                </template>
              </div>
              <button v-if="cart.use_coupon_discount && cart.coupon_discount_value <= 0" class="couponBtn" @click="showCoupon(true)">{{$t('addOrder.couponBtn')}}</button>
              <button v-if="cart.use_coupon_discount && cart.coupon_discount_value > 0" class="couponBtn" @click="applyCoupon(false)">{{$t('addOrder.removeCoupon')}}</button>

              <template v-if="json.type != 'Kiosk'">
                <button v-if="cart.use_tips && cart.order_totals.find( ({ name }) => name === 'Tip').value <= 0" 
                        @click="addOrRemoveTip(1)" 
                        class="tips"
                        >{{$t('addOrder.addTip')}}</button>
                <button v-if="cart.use_tips && cart.order_totals.find( ({ name }) => name === 'Tip').value > 0" 
                        @click="addOrRemoveTip(0)" 
                        class="tips"
                        >{{$t('addOrder.removeTip')}}</button>
              </template>
            </div>
          </div>
        </div>

        <div class="footer" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
          <!-- <div class="bottomPart"> -->
            <!-- <div class="textAndBtns">
              <div class="textarea">
                <textarea name="comentariu" cols="30" rows="5" :placeholder="$t('addOrder.coment')" v-model="orderComent"></textarea>
              </div>
            </div> -->
            <div class="addToCart">
              <!-- <div class="addToCart__left">
                <img :src="'../TapTasty.svg'" alt="TapTasty">
              </div> -->
              <div class="footer__backbtn">
                <button class="backButon" @click="showCartModal = false">
                  <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                        <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                      </svg>
                  {{$t('addOrder.back')}}
                </button>
              </div>


              <div class="addToCart__right">
                <div class="total"> 
                  <span>{{$t('addOrder.total')}}</span>
                  <span v-html="cart.myCart.total_cart_price + ' ' + currency_symbol"></span>
                </div>
                <button class="orderNow" @click="payNew()">{{$t('addOrder.orderNow')}}</button>
              </div>
            </div>
          <!-- </div>  -->
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="paymentModal"
            v-model="showPaymentModal"
            :hideOverlay="true"
            :class="['paymentModal', showPaymentModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="modal__wrapper">

        <div class="modal_bg" v-if="cart">

          <br><br><br>
          <br><br>
          <div class="logo">
            <img :src="companyLogo" alt="logo">
          </div>
          <br><br><br>
          <br><br>
          <br>

          <div :class="['prev_totals_wrapper', use_pager ? 'with_pager' : '']" v-if="!qr_code && addProductInCartRequest == 0">
            <div class="product__wrapper">
              <template v-for="prod in cart.myCart.products" v-bind:key="prod.id">
                <div class="product">
                    <div class="description">
                      <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                      <!-- <span class="product__extra" v-if="prod.extra">{{prod.extra}}</span> -->
                      <template v-if="prod.extra">
                        <span 
                            v-for="(part, index) in prod.extra.split(',')" 
                            :key="index"
                            class="product__extra"
                        >
                            {{ index === 0 ? part.trim() : part.trim() }}
                        </span>
                      </template>
                      <span class="product__additional_info" v-if="prod.additional_info">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                      <span class="product__is_bonus" v-if="prod.is_bonus">{{$t('addOrder.freeProd')}}</span>
                    </div>
                    <div class="quantity">
                      <span>{{prod.quantity}}</span>
                    </div>
                    <div class="product_price">
                      <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                    </div>
                </div>
              </template>
              <template v-for="totalsOptions in cart.order_totals" v-bind:key="totalsOptions.name">
                <template v-if="totalsOptions.use && totalsOptions.value > 0 && totalsOptions.name != 'SGR'">
                  <div class="product">
                    <div class="totalsOptions">
                      <span>{{ getTotalOptionLabel(totalsOptions.name) }}</span>
                    </div>
                    <div class="quantity"></div>
                    <div class="product_price">
                      <span v-html="totalsOptions.value.toFixed(2) + ' ' + currency_symbol"></span>
                    </div>
                  </div>
                </template>
              </template>
            </div>
            <div class="battom_bar">

              <div class="cui_fields">
                 <template v-if="cui">
                  <button @click="openCuiModal()">CUI: {{cui}}</button>
                </template>
                <template v-else>
                  <button @click="openCuiModal()">{{$t('addOrder.cuiPlaceholder')}}</button>
                </template>
              </div>

              <div class="pager_btn" v-if="json.type == 'Kiosk' && use_pager">
                <template v-if="pager">
                  <button class="btnPager" @click="openPagerModal()">{{pager}}</button>
                </template>
                <template v-else>
                  <button class="btnPager" @click="openPagerModal()">{{$t('addOrder.pagerBtn')}}</button>
                </template>
              </div>


              <div class="total_wrapper">
                <div class="" v-if="cart && cart.myCart && cart.myCart">
                  <template v-if="cart.myCart.total_pay_from_wallet">
                    <span style="margin-right: 10px;">{{$t('general.walletPay')}}</span>
                    <span v-html="'-' + cart.myCart.total_pay_from_wallet.toFixed(2) + ' ' + currency_symbol"></span>
                  </template>
                </div>
                <div class="total" v-if="cart && cart.myCart && cart.myCart">
                  <span style="margin-right: 10px;">{{$t('addOrder.total')}}</span>
                  <span v-html="(cart.myCart.total_cart_price - (cart.myCart.total_pay_from_wallet ?? 0)).toFixed(2)  + ' ' + currency_symbol"></span>
                </div>
              </div>

            </div>
          </div>

          <br>

          <template v-if="table_use_tips && cart.use_tips && addProductInCartRequest == 0">
            <template v-if="cart.order_totals.find( ({ name }) => name === 'Tip').value <= 0">
              <button
                  @click="openTipModal()"
                  class="tips addTipsCheckout"
                  >{{$t('addOrder.addTip')}}</button>
            </template>
            <template v-if="cart.order_totals.find( ({ name }) => name === 'Tip').value > 0">
              <button
                @click="addOrRemoveTip(0)"
                class="tips addTipsCheckout"
                >{{$t('addOrder.removeTip')}}</button>
            </template>
          </template>

          <br><br>

          <h2 v-if="addProductInCartRequest == 0">{{$t('addOrder.paymentOptions')}}</h2>
          <div class="qr_code" v-if="qr_code">
            <div class="pack__wrapper__buttons_bg">
              <bgBtns />
            </div>
            <img :src="qr_code" alt="payByQr">
            <p><span>{{$t('addOrder.qrText')}}</span> <span> <div>{{countdown}}</div> </span> <span>{{$t('addOrder.qrText2')}}</span></p>
            <button class="qrCancel" @click="restart()">{{$t('addOrder.qrCancel')}}</button>
          </div>

          <div class="qr_code_steps" v-if="qr_code">
            <span>{{$t('addOrder.qrStep1')}}</span>
            <span>{{$t('addOrder.qrStep2')}}</span>
            <span>{{$t('addOrder.qrStep3')}}</span>
            <span>{{$t('addOrder.qrStep4')}}</span>
          </div>

          <div class="payment__buttons" v-if="!qr_code && addProductInCartRequest == 0">
            <div class="pack__wrapper__buttons_bg">
              <bgBtns />
            </div>

            <!-- Lista de metode de plata e scrollabila cand sunt multe optiuni,
                 ca sa nu intre peste butonul "Inapoi la meniu" (backShopping). -->
            <div class="payment__buttons__scroll">

            <div :class="[disablePaymentClass, 'viva_walet take', 'load_viva_walet']" @click="orderNow('viva_walet')" v-if='withVivaWallet && cart && cart.myCart && (cart.myCart.total_cart_price - (cart.myCart.total_pay_from_wallet || 0)) > 0'>
              <posSvg />
              <span>{{$t('addOrder.viva_walet')}}</span>
            </div>

            <div :class="[disablePaymentClass, 'pos', 'load_card_pos']" @click="orderNow('card_pos')" v-if='posPaymentEnabled && cart && cart.myCart && cart.myCart.total_cart_price > 0'>
              <posSvg />
              <template v-if="this.json.company_id == 145">
                <span>Card aici</span>
              </template>
              <template v-else>
                <span>{{$t('addOrder.pos')}}</span>
              </template>
            </div>

            <div class="pos_offline" v-if='posOffline && !posPaymentEnabled && cart && cart.myCart && cart.myCart.total_cart_price > 0'>
              <posSvg />
              <span class="pos_offline__msg">{{$t('addOrder.posOffline')}}</span>
              <button class="pos_offline__retry" :class="{ 'is-loading': posRetrying }" :disabled="posRetrying" @click="retryPosOnline()">
                {{$t('addOrder.posRetry')}}
              </button>
            </div>

            <div :class="[disablePaymentClass, 'take', 'load_k_qr']" @click="orderNow('qr')" v-if='cardPaymentEnabled && cardQrPaymentEnabled'>
              <qrSvg />
              <span>{{$t('addOrder.qr')}}</span>
            </div>
            <div :class="[disablePaymentClass, 'din', 'load_k_cash']" @click="orderNow('cash')" v-if='cashPaymentEnabled'>
              <counterSvg />
              <template v-if="this.json.company_id == 145">
                <span>Cash in restaurant</span>
              </template>
              <template v-else>
                <span>{{$t('addOrder.counter_cash')}}</span>
              </template>
            </div> 

            <div :class="[disablePaymentClass, 'din', 'load_k_pos']" @click="orderNow('pos')" v-if='kioskPosOnDeliveryPaymentEnabled'>
              <posSvg />
              <span>{{$t('addOrder.counter_pos')}}</span>
            </div>

            <div :class="[disablePaymentClass, 'din', 'load_cashMachine']" @click="orderNow('cashMachine')" v-if='isUsingCashMachine'>
              <counterSvg />
              <span>Cash Machine</span>
            </div>

            <div :class="[disablePaymentClass, 'free', 'load_free']" @click="orderNow('free')" v-if='freePaymentEnabled && cart && cart.myCart && (cart.myCart.total_cart_price - (cart.myCart.total_pay_from_wallet || 0)) <= 0'>
              <freeSvg />
              <span>{{$t('addOrder.free')}}</span>
            </div>

            </div>
          </div>

          <div class="payment__buttons" v-if="addProductInCartRequest != 0">
            <h2>{{$t('addOrder.weitingForAddToCartToFinish')}}</h2>
          </div>

          <div class="backShopping" v-if="!qr_code">
            <button @click="unfreezeOrder()"><svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                  <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                </svg><span>{{$t('addOrder.backShopping')}}</span></button>
          </div>
        </div>
      </div>
    </vue-final-modal>


    <!-- Tip Selection Modal -->
    <vue-final-modal
        name="tipModal"
        v-model="showTipModal"
        :hideOverlay="true"
        :class="['smallModal', 'tipModal', showTipModal ? 'active' : '']"
        classes="modal-container"
        content-class="modal-content"
      >
      <div class="smallModal__wrapper">
        <div class="modal_bg">
          
          <div class="tip-modal-header">
            <h2>{{ $t('addOrder.selectTip') }}</h2>
            <button class="close-btn" @click="closeTipModal()">✕</button>
          </div>

          <div class="tip-buttons-grid">
            <template v-for="(tipValue, index) in getValidTipValues()" :key="index">
              <button
                :class="['tip-btn', isSelectedTip(tipValue) ? 'active' : '', 'bl' + getValidTipValues().length]"
                @click="applyTip(tipValue)"
              >
                <span class="tip-amount">{{ tipValue }}</span>
                <span class="tip-label" v-if="tip_suggestion.type === 'proc'">%</span>
                <span class="tip-label" v-else>{{ currency_symbol }}</span>
              </button>
            </template>
          </div>

          <!-- Custom Tip Input -->
          <div class="custom-tip-section">
            <button 
              class="custom-tip-btn"
              @click="openCustomTipModal()"
            >
              <span>{{ $t('addOrder.customTip') }}</span>
              <!-- <span v-if="customTipValue > 0" class="custom-tip-value">
                {{ parseFloat(customTipValue).toFixed(2) }} {{ currency_symbol }}
              </span> -->
            </button>
          </div>

        </div>
      </div>
    </vue-final-modal>

    <!-- Custom Tip Input Modal (simplu, pentru kiosk) -->
    <vue-final-modal
        name="customTipModal"
        v-model="showCustomTipModal"
        :hideOverlay="true"
        :class="['smallModal', 'customTipModal', showCustomTipModal ? 'active' : '']"
        classes="modal-container"
        content-class="modal-content"
      >
      <div class="smallModal__wrapper">
        <div class="modal_bg custom-tip-bg">
          
          <h2>{{ $t('addOrder.enterCustomTip') }}</h2>
          
          <div class="custom-tip-display">
            <span class="tip-input-value">{{ customTipInput || '0.00' }}</span>
            <span class="tip-currency">{{ currency_symbol }}</span>
          </div>

          <!-- Keypad numeric pentru kiosk -->
          <div class="numpad-grid">
            <button v-for="n in 9" :key="n" @click="appendToCustomTip(n)" class="numpad-btn">
              {{ n }}
            </button>
            <button @click="appendToCustomTip('.')" class="numpad-btn">.</button>
            <button @click="appendToCustomTip(0)" class="numpad-btn">0</button>
            <button @click="backspaceCustomTip()" class="numpad-btn">⌫</button>
          </div>

          <div class="custom-tip-actions">
            <button class="btn-cancel" @click="closeCustomTipModal()">
              {{ $t('general.cancel') }}
            </button>
            <button 
              class="btn-confirm" 
              @click="confirmCustomTip()"
              :disabled="!customTipInput || parseFloat(customTipInput) <= 0"
            >
              {{ $t('general.confirm') }}
            </button>
          </div>

        </div>
      </div>
    </vue-final-modal>

    <!-- History Z / Bon Modal (kiosk, cu tastatura numerica proprie) -->
    <vue-final-modal
        name="historyModal"
        v-model="showHistoryModal"
        :hideOverlay="true"
        :class="['smallModal', 'customTipModal', 'historyModal', showHistoryModal ? 'active' : '']"
        classes="modal-container"
        content-class="modal-content"
      >
      <div class="smallModal__wrapper">
        <div class="modal_bg custom-tip-bg">

          <h2 v-if="historyMode === 'z'">GET HISTORY Z</h2>
          <h2 v-else>GET HISTORY BON</h2>

          <!-- Modul Z: un singur camp -->
          <template v-if="historyMode === 'z'">
            <p class="history-hint">Numarul raportului Z</p>
            <div class="custom-tip-display">
              <span class="tip-input-value">{{ historyZetInput || '0' }}</span>
            </div>
          </template>

          <!-- Modul Bon: doua campuri (nr. bon + nr. zet) -->
          <template v-else>
            <div class="history-fields">
              <div class="history-field" :class="{ active: historyActiveField === 'bon' }" @click="setHistoryField('bon')">
                <span class="history-field__label">Nr. bon</span>
                <span class="history-field__value">{{ historyBonInput || '0' }}</span>
              </div>
              <div class="history-field" :class="{ active: historyActiveField === 'zet' }" @click="setHistoryField('zet')">
                <span class="history-field__label">Nr. zet</span>
                <span class="history-field__value">{{ historyZetInput || '0' }}</span>
              </div>
            </div>
          </template>

          <!-- Tastatura numerica (aceeasi ca la bacsis) -->
          <div class="numpad-grid">
            <button v-for="n in 9" :key="n" @click="historyAppend(n)" class="numpad-btn">{{ n }}</button>
            <button class="numpad-btn numpad-btn--empty" disabled></button>
            <button @click="historyAppend(0)" class="numpad-btn">0</button>
            <button @click="historyBackspace()" class="numpad-btn">⌫</button>
          </div>

          <div class="custom-tip-actions">
            <button class="btn-cancel" @click="closeHistoryModal()">
              {{ $t('general.cancel') }}
            </button>
            <button
              class="btn-confirm"
              @click="historyConfirm()"
              :disabled="historyMode === 'z' ? !historyZetInput : (!historyBonInput || !historyZetInput)"
            >
              {{ $t('general.confirm') }}
            </button>
          </div>

        </div>
      </div>
    </vue-final-modal>

    <!-- Cauta comanda (kiosk): ultimele comenzi ale acestui kiosk, paginat -->
    <vue-final-modal
        name="searchOrderModal"
        v-model="showSearchOrderModal"
        :hideOverlay="true"
        class="searchOrderModal"
        classes="modal-container"
        content-class="modal-content"
      >
      <div class="iframeModal__wrapper searchOrderModal__wrapper">
        <div class="xModalBtn" @click="closeSearchOrderModal()"><span>x</span></div>
        <h1>Cauta comanda</h1>
        <p class="searchOrder__subtitle">Comenzile din ultimele 24h</p>

        <!-- Filtru numeric (tastatura numerica proprie) -->
        <div class="searchOrder__filter">
          <div class="searchOrder__filter-fields">
            <div
              class="searchOrder__filter-field"
              :class="{ active: searchActiveFilterField === 'id' }"
              @click="setSearchFilterField('id')"
            >
              <span class="searchOrder__filter-label">ID comanda</span>
              <span class="searchOrder__filter-value">{{ searchFilterId || '—' }}</span>
            </div>
            <div
              class="searchOrder__filter-field"
              :class="{ active: searchActiveFilterField === 'number' }"
              @click="setSearchFilterField('number')"
            >
              <span class="searchOrder__filter-label">Numar comanda</span>
              <span class="searchOrder__filter-value">{{ searchFilterNumber || '—' }}</span>
            </div>
            <div
              class="searchOrder__filter-field"
              :class="{ active: searchActiveFilterField === 'total' }"
              @click="setSearchFilterField('total')"
            >
              <span class="searchOrder__filter-label">Total comanda</span>
              <span class="searchOrder__filter-value">{{ searchFilterTotal || '—' }}</span>
            </div>
          </div>

          <div class="searchOrder__numpad">
            <button v-for="n in 9" :key="n" class="searchOrder__numpad-btn" @click="searchFilterAppend(n)">{{ n }}</button>
            <button
              class="searchOrder__numpad-btn"
              :class="{ 'searchOrder__numpad-btn--muted': searchActiveFilterField !== 'total' }"
              @click="searchFilterAppend('.')"
            >.</button>
            <button class="searchOrder__numpad-btn" @click="searchFilterAppend(0)">0</button>
            <button class="searchOrder__numpad-btn" @click="searchFilterBackspace()">⌫</button>
          </div>

          <div class="searchOrder__filter-actions">
            <button class="searchOrder__btn searchOrder__btn--reset" @click="resetSearchFilter()" :disabled="searchOrdersLoading">Reset</button>
            <button class="searchOrder__btn searchOrder__btn--search" @click="applySearchFilter()" :disabled="searchOrdersLoading">Cauta</button>
          </div>
        </div>

        <div class="searchOrder__loading" v-if="searchOrdersLoading">Se incarca...</div>

        <div class="searchOrder__empty" v-else-if="!searchOrders.length">Nu exista comenzi.</div>

        <div class="searchOrder__list" v-else>
          <div class="searchOrder__row" v-for="order in searchOrders" :key="order.order_id">
            <div class="searchOrder__main">
              <div class="searchOrder__cell searchOrder__id">{{ order.order_id }}</div>
              <div class="searchOrder__cell searchOrder__nr">{{ order.serie_numar || order.number }}</div>
              <div class="searchOrder__cell searchOrder__total">{{ order.total }} {{ order.currency || currency_symbol }}</div>
              <div class="searchOrder__cell searchOrder__fiscal">
                <template v-if="searchOrderHasFiscal(order)">
                  <span>Z: {{ order.fiscal_nrz }}</span>
                  <span>Bon: {{ order.fiscal_nr }}</span>
                </template>
                <span v-else class="searchOrder__nofiscal">Nefiscalizat</span>
              </div>
              <div class="searchOrder__cell searchOrder__actions">
                <button
                  v-if="searchOrderHasFiscal(order)"
                  class="searchOrder__btn searchOrder__btn--reprint"
                  @click="reprintOrderBon(order)"
                >Reprinteaza bon</button>
                <button
                  v-else
                  class="searchOrder__btn searchOrder__btn--fiscal"
                  @click="fiscalizeOrderFromSearch(order)"
                >Fiscalizare</button>
                <button
                  class="searchOrder__btn searchOrder__btn--toggle"
                  @click="toggleSearchOrderProducts(order)"
                >{{ expandedSearchOrderId === order.order_id ? '▲' : '▼' }}</button>
              </div>
            </div>

            <div class="searchOrder__products" v-if="expandedSearchOrderId === order.order_id">
              <div class="searchOrder__products-loading" v-if="expandedSearchOrderLoading">Se incarca produsele...</div>
              <template v-else>
                <div class="searchOrder__product" v-for="(prod, pi) in expandedSearchOrderProducts" :key="pi">
                  <div class="searchOrder__product-line">
                    <span class="searchOrder__product-qty">{{ prod.quantity }}x</span>
                    <span class="searchOrder__product-name">{{ prod.name }}</span>
                    <span class="searchOrder__product-price">{{ prod.price }} {{ order.currency || currency_symbol }}</span>
                  </div>
                  <div class="searchOrder__product-extra" v-if="prod.extra">{{ prod.extra }}</div>
                </div>
                <div class="searchOrder__product" v-if="!expandedSearchOrderProducts.length">Fara produse.</div>
              </template>
            </div>
          </div>
        </div>

        <div class="searchOrder__pagination" v-if="searchOrders.length">
          <button
            class="searchOrder__btn"
            :disabled="searchOrdersPage <= 1 || searchOrdersLoading"
            @click="searchOrdersPrevPage()"
          >‹ Inapoi</button>
          <span class="searchOrder__page">{{ searchOrdersPage }} / {{ searchOrdersLastPage }}</span>
          <button
            class="searchOrder__btn"
            :disabled="searchOrdersPage >= searchOrdersLastPage || searchOrdersLoading"
            @click="searchOrdersNextPage()"
          >Inainte ›</button>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="clientModal"
            v-model="showClientModal"
            :hideOverlay="true"
            :class="['clientModal', showClientModal ? 'active': '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="modal__wrapper">

        <div class="modal_bg">
          <br><br><br>
          <div class="logo">
            <img :src="companyLogo" alt="logo">
          </div>
          <br><br><br>

          <template v-if="loyalty_in_use && !use_smso">
            <h2>{{$t('addOrder.loyalityNoSms')}}</h2>
          </template>
          <template v-if="!loyalty_in_use && use_smso">
            <h2>{{$t('addOrder.noLoyalitySms')}}</h2>
          </template>
          <template v-if="loyalty_in_use && use_smso">
            <h2>{{$t('addOrder.loyalitySms')}}</h2>
          </template>
          

          <div class="payment__buttons">
            <div class="email_fields keyboard-phone-layout">
              <h4>{{$t('addOrder.phoneFieldsTitle1')}}</h4>
              <!-- <input id="phone_to_send" type="tel" v-model="phone_to_send" :placeholder="$t('addOrder.phonePlaceholder')"> -->

              <!-- @keyup.enter="searchForClient()" -->
              <div class="phone_key_wrapper">
                <div v-show="!client && !new_client">
                  <div class="inputPhone" >
                    <MazPhoneNumberInput
                      ref="clientPhoneField"
                      noFormattingAsYouType="false"
                      @click="changePhone()"
                      v-model="phone_to_send"
                      v-model:country-code="countryCode"
                      show-code-on-list  
                      @update="resultsPhone = $event"
                    />
                  </div>
                  <div class="simple-keyboard-client" v-show="activeKeyboardClient"></div>
                </div>

                <div class="client_fields" v-show="client || new_client">
                  <!-- <p v-if="client">Client: {{client.firstname}} {{client.lastname}}</p> -->
                  <p v-if="client">Client: {{maskPhoneNumber(client.phone)}}</p>
                  <p v-if="new_client">Client Nou: {{maskPhoneNumber(order_phone)}}</p>
                  <div class="loyaltyPoints" v-if="withAllowLoyality">
                    <p v-if="client && client.lastname" style="font-size: 30px;">{{$t('general.loyaltyPointsText')}} {{client.lastname}}: {{client.loyalty_points}}</p>
                    <button v-if="cart && cart.use_loyalty_points && !cart.loyalty_discount_value" @click="useOrRemoveLoyaltyPoints(1)" class="loyalty_points">{{$t('general.applyLoyalty')}}</button>
                    <button v-if="cart && cart.use_loyalty_points && cart.loyalty_discount_value" @click="useOrRemoveLoyaltyPoints(0)" class="loyalty_points">{{$t('general.removeLoyalty')}}</button>

                    <div class="wallet">
                      <p v-if="client && client.lastname" style="font-size: 30px;">{{$t('general.walletTotalText')}} {{client.lastname}}: {{client.wallet_value}} {{currency_symbol}}</p>
                      <button v-if="cart && !cart.myCart.total_pay_from_wallet && client && client.wallet_value" @click="openWalletPopup()" class="loyalty_points">{{$t('general.applyWallet')}}</button>

                      <button v-if="cart && cart.myCart.total_pay_from_wallet" @click="removeFromWallet()" class="loyalty_points">{{$t('general.removeWallet')}} ({{cart.myCart.total_pay_from_wallet}} {{currency_symbol}}) </button>
                    </div>
                  </div>
                  <!-- <p v-if="new_client && loyalty_in_use" class="new_client">{{$t('addOrder.new_client_fidelity')}}</p> -->
                  <button @click="removeClient()">{{$t('general.cancel')}}</button>
                </div>
              </div>
            </div>
          </div>

          <div class="backShopping">
            <button @click="validateAndContinueToPay()"><span>{{$t('addOrder.continueToPay')}}</span><svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                  <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                </svg></button>
          </div>

          <div class="scan__img__wrapper">
            <h4 style="margin-bottom: 0;">{{$t('addOrder.phoneFieldsTitle2')}}</h4>
            <template v-if="scaner_position == 'left'">
              <img :src="'../scan_left.png'" alt="scan_left">
            </template>
            <template v-else-if="scaner_position == 'right'">
              <img :src="'../scan_right.png'" alt="scan_right">
            </template>
            <template v-else>
              <img :src="'../scan.png'" alt="scan">
            </template>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="splashScreenModal"
            v-model="showSplashScreenModal"
            :hideOverlay="true"
            :class="['splashScreenModal', showSplashScreenModal ? 'active': '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div :class="['splash_wrapper', !packed ? 'active' : '']" >
        <template v-if="splashScreenBanners.length" v-for="(screen, key_s) in splashScreenBanners">
          <div :class="[nextSplashScreenSlider == key_s ? '' : 'hiden', 'splashScreen__wrapper']" 
              @click="exitSplashScreen()" 
              :style="'background-image: url(' + screen.image_landing + ');'"
          >
          </div>
        </template>
        <div class="splashScreen__wrapper defaultOne" 
              v-if="splashScreenBanners.length <= 0"
              @click="exitSplashScreen()" 
              style="background-color: var(--secundar)"
          >
          <div class="model" style="position: relative; overflow: hidden;">
              <!-- <splashIcons width="140%" top="auto" left="auto" /> -->
            <img :src="companyLogo" alt="logo">
          </div>
          <div class="text">
            <p>{{$t('addOrder.splashScreenWrapperStart')}}</p>
          </div>
        </div>
      </div>
      <div :class="['question_wrapper active']" >
        <template v-if="this.json.company_id == 46 || this.json.company_id == 91">
          <div class="pack__wrapper"
              v-if="packed">
            <!-- <div :class="(listOfLangIsOpen) ? 'lang_btn open' : 'lang_btn' ">
              <a @click.prevent="openListOfLang()">
                <img :src="'../' + curentLang + '.png'" alt="lang">
              </a>
              <div class="listOfLang">
                <template v-for="lng in allLang" :key="lng">
                  <a @click.prevent="changeLanguageLocal(lng)" v-if="lng != curentLang">
                    <img :src="'../' + lng + '.png'" alt="lng">
                  </a>
                </template>
              </div>
            </div> -->
            <div class="splash_bg" style="background-image: url('../splash_yumm.jpg');"></div>
            <div class="bg_splash_wrapper">
              <h2 style="margin-bottom:0;">{{$t('addOrder.chooseLanguage')}}</h2>
              <div class="languageBtns" style="margin-bottom:0;">
                <button
                  v-for="lng in allLang"
                  :key="lng"
                  :class="['lang', lng, curentLang == lng ? 'selected' : '']"
                  @click.prevent="changeLanguageLocal(lng, 1)"><img :src="langFlagSrc(lng)" :alt="langLabel(lng)" @error="$event.target.style.display='none'"><span>{{ langLabel(lng) }}</span>
                </button>
              </div>
              <div class="pack__wrapper__buttons">
                <div class="din" @click="chooseMetod('dineIn')">
                  <!-- <img :src="'../din.svg'" alt="din"> -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="280" height="280" viewBox="0 0 280 280">
                    <g id="Group_12317" data-name="Group 12317" transform="translate(0 0.488)">
                      <circle id="Ellipse_419" data-name="Ellipse 419" cx="140" cy="140" r="140" transform="translate(0 -0.488)" fill="inherit"/>
                      <g id="Group_12315" data-name="Group 12315" transform="translate(88.117 80.537)">
                        <path id="Union_4" data-name="Union 4" d="M24.876,117a3,3,0,0,1-3-3V58.164A29.482,29.482,0,0,1,0,29.658V4A4,4,0,0,1,4,0h7.248a4,4,0,0,1,4,4V21.224a3.974,3.974,0,0,0,6.629,0V4a4,4,0,0,1,4-4h7.247a4,4,0,0,1,4,4V21.224a3.974,3.974,0,0,0,6.629,0V4a4,4,0,0,1,4-4H55a4,4,0,0,1,4,4V29.658A29.512,29.512,0,0,1,37.123,58.164V114a3,3,0,0,1-3,3Z" transform="translate(-0.117 -0.026)" fill="#fff"/>
                        <path id="Union_5" data-name="Union 5" d="M4,117a4,4,0,0,1-4-4V.056C.656.018,1.317,0,1.964,0A33.829,33.829,0,0,1,15.213,2.675,33.928,33.928,0,0,1,26.031,9.969a33.907,33.907,0,0,1,7.294,10.819A33.821,33.821,0,0,1,36,34.036V47.469a33.826,33.826,0,0,1-2.675,13.249,33.917,33.917,0,0,1-7.294,10.819,33.928,33.928,0,0,1-10.818,7.295q-.3.126-.6.247a3.984,3.984,0,0,1,.441,1.827V113a4,4,0,0,1-4,4Z" transform="translate(66.883 -0.026)" fill="#fff"/>
                      </g>
                    </g>
                  </svg>
                  <span>{{$t('addOrder.dineIn')}}</span>
                </div>
                <div class="take" @click="chooseMetod('takeAway')">
                  <!-- <img :src="'../take.svg'" alt="take"> -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="279" height="280" viewBox="0 0 279 280">
                    <g id="Group_12318" data-name="Group 12318" transform="translate(-0.044 0.488)">
                      <ellipse id="Ellipse_420" data-name="Ellipse 420" cx="139.5" cy="140" rx="139.5" ry="140" transform="translate(0.044 -0.488)" fill="inherit"/>
                      <path id="Subtraction_13" data-name="Subtraction 13" d="M117,171H26A25.978,25.978,0,0,1,0,145V77.425a25.978,25.978,0,0,1,26-26H36.491c-.005-.289-.007-.522-.007-.733V35.016a35.016,35.016,0,1,1,70.033,0V50.693c0,.229,0,.469-.007.733H117a25.979,25.979,0,0,1,26,26V145a25.978,25.978,0,0,1-26,26ZM83.032,76.093c-.42,0-.844.012-1.258.036V127.9l.049,0,.1.005a4.008,4.008,0,0,0-.153,1.1v17.5a4,4,0,0,0,4,4h1.645a4,4,0,0,0,4-4v-17.5a3.963,3.963,0,0,0-.814-2.417,21.855,21.855,0,0,0,14.233-20.462V97.9A21.808,21.808,0,0,0,83.032,76.093ZM38.624,78.184c-.029.413-.044.846-.044,1.287v15.59A18.683,18.683,0,0,0,52.5,113.116a3.029,3.029,0,0,0-.077.68v33.719a3,3,0,0,0,3,3h3.645a3,3,0,0,0,3-3V113.8a3.03,3.03,0,0,0-.077-.68A18.682,18.682,0,0,0,75.9,95.061V79.471c0-.43-.015-.863-.044-1.287h-.44A4,4,0,0,0,71.9,76.093H70.258a4,4,0,0,0-3.515,2.091h-.065v.124a3.96,3.96,0,0,0-.419,1.785V89.6a2.515,2.515,0,0,1-4.194,0V80.093a3.961,3.961,0,0,0-.419-1.785v-.124H61.58a4,4,0,0,0-3.515-2.091H56.419A4,4,0,0,0,52.9,78.184h-.065v.124a3.961,3.961,0,0,0-.419,1.785V89.6a2.514,2.514,0,0,1-4.193,0V80.093a3.961,3.961,0,0,0-.419-1.785v-.124h-.065a4,4,0,0,0-3.516-2.091H42.58a4,4,0,0,0-3.515,2.091ZM71.5,21.74A12.805,12.805,0,0,0,58.71,34.531V51.425H84.29V34.531A12.8,12.8,0,0,0,71.5,21.74Z" transform="translate(68.044 43.512)" fill="#fff"/>
                    </g>
                  </svg>
                  <span>{{$t('addOrder.takeAway')}}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="modal__wrapper">
            <!-- <div :class="(listOfLangIsOpen) ? 'lang_btn open' : 'lang_btn' ">
              <a @click.prevent="openListOfLang()">
                <img :src="'../' + curentLang + '.png'" alt="lang">
              </a>
              <div class="listOfLang">
                <template v-for="lng in allLang" :key="lng">
                  <a @click.prevent="changeLanguageLocal(lng)" v-if="lng != curentLang">
                    <img :src="'../' + lng + '.png'" alt="lng">
                  </a>
                </template>
              </div>
            </div> -->

            <!-- <div class="top__pack__wrapper">
              <div class="model" style="position: relative;">
                <splashIcons width="100%" top="auto" left="auto" />
                <img :src="companyLogo" alt="logo">
              </div>
            </div> -->

            <div class="modal_bg">

              <br><br><br>
              <br><br><br>
              <div class="logo">
                <img :src="companyLogo" alt="logo">
              </div>
              <br><br><br>
              <template v-if="justCardTxtToKiosk">
                <br>
                <h2 style="width: 80%;">Plata la acest Kiosk se poate face doar cu CARDUL!</h2>
              </template>
              <template v-else>
                <br>
              </template>
              <br><br>

              <div class="center_lg" style="width: 100%; height: 100%; margin-top: 200px; margin-bottom: 100px;">
                
                <div class="languageBtns">
                  <button
                    v-for="lng in allLang"
                    :key="lng"
                    :class="['lang', lng, curentLang == lng ? 'selected' : '']"
                    @click.prevent="changeLanguageLocal(lng, 1)"><img :src="langFlagSrc(lng)" :alt="langLabel(lng)" @error="$event.target.style.display='none'"><span>{{ langLabel(lng) }}</span>
                  </button>
                </div>

                <!-- <div class="roundbg"></div> -->
                <h2>{{$t('addOrder.pack')}}</h2>
                <div class="pack__wrapper__buttons">
                  <div class="pack__wrapper__buttons_bg">
                    <bgBtns />
                  </div>
                  <div class="din" @click="chooseMetod('dineIn')">
                    <!-- <img :src="'../din.svg'" alt="din"> -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="280" height="280" viewBox="0 0 280 280">
                      <g id="Group_12317" data-name="Group 12317" transform="translate(0 0.488)">
                        <circle id="Ellipse_419" data-name="Ellipse 419" cx="140" cy="140" r="140" transform="translate(0 -0.488)" fill="inherit"/>
                        <g id="Group_12315" data-name="Group 12315" transform="translate(88.117 80.537)">
                          <path id="Union_4" data-name="Union 4" d="M24.876,117a3,3,0,0,1-3-3V58.164A29.482,29.482,0,0,1,0,29.658V4A4,4,0,0,1,4,0h7.248a4,4,0,0,1,4,4V21.224a3.974,3.974,0,0,0,6.629,0V4a4,4,0,0,1,4-4h7.247a4,4,0,0,1,4,4V21.224a3.974,3.974,0,0,0,6.629,0V4a4,4,0,0,1,4-4H55a4,4,0,0,1,4,4V29.658A29.512,29.512,0,0,1,37.123,58.164V114a3,3,0,0,1-3,3Z" transform="translate(-0.117 -0.026)" fill="#fff"/>
                          <path id="Union_5" data-name="Union 5" d="M4,117a4,4,0,0,1-4-4V.056C.656.018,1.317,0,1.964,0A33.829,33.829,0,0,1,15.213,2.675,33.928,33.928,0,0,1,26.031,9.969a33.907,33.907,0,0,1,7.294,10.819A33.821,33.821,0,0,1,36,34.036V47.469a33.826,33.826,0,0,1-2.675,13.249,33.917,33.917,0,0,1-7.294,10.819,33.928,33.928,0,0,1-10.818,7.295q-.3.126-.6.247a3.984,3.984,0,0,1,.441,1.827V113a4,4,0,0,1-4,4Z" transform="translate(66.883 -0.026)" fill="#fff"/>
                        </g>
                      </g>
                    </svg>
                    <span>{{$t('addOrder.dineIn')}}</span>
                  </div>
                  <div class="take" @click="chooseMetod('takeAway')">
                    <!-- <img :src="'../take.svg'" alt="take"> -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="279" height="280" viewBox="0 0 279 280">
                      <g id="Group_12318" data-name="Group 12318" transform="translate(-0.044 0.488)">
                        <ellipse id="Ellipse_420" data-name="Ellipse 420" cx="139.5" cy="140" rx="139.5" ry="140" transform="translate(0.044 -0.488)" fill="inherit"/>
                        <path id="Subtraction_13" data-name="Subtraction 13" d="M117,171H26A25.978,25.978,0,0,1,0,145V77.425a25.978,25.978,0,0,1,26-26H36.491c-.005-.289-.007-.522-.007-.733V35.016a35.016,35.016,0,1,1,70.033,0V50.693c0,.229,0,.469-.007.733H117a25.979,25.979,0,0,1,26,26V145a25.978,25.978,0,0,1-26,26ZM83.032,76.093c-.42,0-.844.012-1.258.036V127.9l.049,0,.1.005a4.008,4.008,0,0,0-.153,1.1v17.5a4,4,0,0,0,4,4h1.645a4,4,0,0,0,4-4v-17.5a3.963,3.963,0,0,0-.814-2.417,21.855,21.855,0,0,0,14.233-20.462V97.9A21.808,21.808,0,0,0,83.032,76.093ZM38.624,78.184c-.029.413-.044.846-.044,1.287v15.59A18.683,18.683,0,0,0,52.5,113.116a3.029,3.029,0,0,0-.077.68v33.719a3,3,0,0,0,3,3h3.645a3,3,0,0,0,3-3V113.8a3.03,3.03,0,0,0-.077-.68A18.682,18.682,0,0,0,75.9,95.061V79.471c0-.43-.015-.863-.044-1.287h-.44A4,4,0,0,0,71.9,76.093H70.258a4,4,0,0,0-3.515,2.091h-.065v.124a3.96,3.96,0,0,0-.419,1.785V89.6a2.515,2.515,0,0,1-4.194,0V80.093a3.961,3.961,0,0,0-.419-1.785v-.124H61.58a4,4,0,0,0-3.515-2.091H56.419A4,4,0,0,0,52.9,78.184h-.065v.124a3.961,3.961,0,0,0-.419,1.785V89.6a2.514,2.514,0,0,1-4.193,0V80.093a3.961,3.961,0,0,0-.419-1.785v-.124h-.065a4,4,0,0,0-3.516-2.091H42.58a4,4,0,0,0-3.515,2.091ZM71.5,21.74A12.805,12.805,0,0,0,58.71,34.531V51.425H84.29V34.531A12.8,12.8,0,0,0,71.5,21.74Z" transform="translate(68.044 43.512)" fill="#fff"/>
                      </g>
                    </svg>
                    <span>{{$t('addOrder.takeAway')}}</span>
                  </div>
                </div>
              </div>

              <div class="logo_t" style="position: absolute; bottom: 50px; left: 0; right: 0;"><img :src="'../TapTasty.svg'" alt="TapTasty"></div>
            </div>
          </div>
        </template>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="completeModal"
            v-model="showCompleteModal"
            :hideOverlay="true"
            :class="['completeModal', showCompleteModal ? 'active': '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="complete__wrapper">
        <div class="modal__wrapper">
          <!-- <div class="model" style="position: relative;">
            <splashIcons width="100%" top="-100px" left="0" />
            <img :src="companyLogo" alt="logo">
          </div> -->
        
          <div class="modal_bg">

            <br><br><br>
            <br><br><br>
            <div class="logo">
              <img :src="companyLogo" alt="logo">
            </div>
            <br><br><br>
            <br><br><br>

            <!-- <div class="roundbg"></div> -->

            <div class="title_wrapper">
              <div class="dialog" style="background-image: url('./dialog.png');">
                <span>{{$t('addOrder.doneShortly')}}</span>
              </div>
              <h2>{{$t('addOrder.thenks')}}</h2>
            </div>

            <div class="order_nr_wrapper">
              <div class="pack__wrapper__buttons_bg">
                <bgBtns />
              </div>
              <div class="order_nr">
                <svg xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
                  <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
                    <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
                      <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
                      <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
                    </g>
                  </g>
                </svg>
                <div class="order_nr_txt"> 
                  <span>{{$t('addOrder.yourOrderNr')}}</span>
                  <span>{{finishOrderNr}}</span>
                </div>
              </div>
            </div>

            <!-- <template v-if="json.company_id == 263"> -->
            <template v-if="justCardTxtToKiosk">
              <div class="steps" style="max-width: 80%;">
                <div class="step">
                  <div class="step_round">1</div>
                  <span style="font-size: 3.18rem;">Mergeți la bar pentru a ridica pagerul dumneavoastră.</span>
                </div>
                <div class="step">
                  <div class="step_round">2</div>
                  <span style="font-size: 3.18rem;">Personalul nostru vă așteaptă!</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="steps">
                <div class="step">
                  <div class="step_round">1</div>
                  <span>{{$t('addOrder.step1')}}</span>
                </div>
                <div class="step">
                  <div class="step_round">2</div>
                  <span>{{$t('addOrder.step2')}}</span>
                </div>
              </div>
            </template>
            

            <div class="back">
              <button @click="restart">{{$t('addOrder.back')}}</button>
            </div>
          </div>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="posModal"
            v-model="showPosModal"
            :hideOverlay="true"
            class="posModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="posModal__wrapper">

        <div style="position: relative;">
          <svg class="rotating" xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
            <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
              <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
                <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
                <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
              </g>
            </g>
          </svg>
          <h2>{{$t('addOrder.payByCard')}}</h2>
        </div>
        <div class="desc">
          <p>{{$t('addOrder.cardDesc1')}}</p>
          <p>{{$t('addOrder.cardDesc2')}}</p>
          <p>{{$t('addOrder.cardDesc3')}}</p>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="completeWaitingModal"
            v-model="showCompleteWaitingModal"
            :hideOverlay="true"
            class="completeWaitingModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="completeWaitingModal__wrapper">

        <div style="position: relative;">
          <svg class="rotating" xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
            <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
              <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
                <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
                <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
              </g>
            </g>
          </svg>
          <template v-if="selectedPaymentMethod == 'card_pos' && DBfiscalNet">
            <h2 style="width: 70%;">{{$t('addOrder.pleaseWaitFiscalReceipt')}}</h2>
          </template>
          <template v-else>
            <h2 style="width: 70%;">{{$t('addOrder.pleaseWait')}}</h2>
          </template>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="cashMachineModal"
            v-model="showCashMachineModal"
            :hideOverlay="true"
            class="cashMachineModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="posModal__wrapper">

        <div style="position: relative;">
          <svg class="rotating" xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
            <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
              <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
                <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
                <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
              </g>
            </g>
          </svg>
          <template v-if="showLoaderCompleteCashMachine">
            <h2>{{$t('addOrder.payByCashMachineDone')}}</h2>
          </template>
          <template v-else>
            <h2>{{$t('addOrder.payByCashMachine')}}</h2>
          </template>
        </div>
        <div class="desc" v-if="cart && cart.myCart && !showLoaderCompleteCashMachine">
          <template v-if="customMsgCashMachine">
            <p>{{customMsgCashMachine}}</p>
          </template>
          <template v-else>
            <template v-if="(cart.myCart.total_cart_price - insertedMoneyInCashMachine) < 0">
              <p>Aparatul va da rest: {{((cart.myCart.total_cart_price - insertedMoneyInCashMachine) * -1)  + ' ' + currency_symbol}} </p>
            </template>
            <template v-else>
              <p>Mai ai de pus: {{(cart.myCart.total_cart_price - insertedMoneyInCashMachine) + ' ' + currency_symbol}}</p>
            </template>
          </template>
          <template v-if="customMsgCashMachine">
            <button @click="cashMachinePayout()">Ok</button>
          </template>
          <template v-else>
            <button @click="cashMachinePayout()">Cancel</button>
          </template>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="couponModal"
            v-model="showCouponModal"
            :hideOverlay="true"
            class="couponModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="couponModal__wrapper" @click="closeCouponModal()">

        <!-- <div class="xModalBtn" @click="showCouponModal = false"><span>x</span></div> -->

        <div class="couponModal__img__wrapper">
          <couponSvg />
        </div>

        <h2>{{$t('addOrder.couponTitle')}}</h2>
        <input type="text" @keyup.enter="applyCoupon(true)" v-model="couponText" :placeholder="$t('addOrder.couponPlaceholder')" name="couponCode" ref="couponCode">
        <button v-if="json.type != 'Kiosk'" @click="applyCoupon(true)">{{$t('addOrder.couponBtn')}}</button>
        <span v-if="json.type == 'Kiosk'">{{$t('addOrder.couponExit')}}</span>

      </div>
    </vue-final-modal>


    <vue-final-modal
            name="walletModal"
            v-model="showWalletModal"
            :hideOverlay="true"
            class="walletModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="couponModal__wrapper" @click="closeWalletModal()">

        <div class="couponModal__img__wrapper">
          <couponSvg />
        </div>

        <h2>{{$t('general.selectWalletValue')}}</h2>
        <input
          type="number"
          v-model="walletValue"
          @keyup.enter="applyWallet"
          :placeholder="$t('general.selectWalletValue')"
        >

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="pagerModal"
            v-model="showPagerModal"
            :hideOverlay="true"
            class="pagerModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="pagerModal__wrapper" @click="closePagerModal()">

        <!-- <div class="xModalBtn" @click="showPagerModal = false"><span>x</span></div> -->
        <div class="centered_box">
          <div class="couponModal__img__wrapper">
            <img :src="'../pager.png'" alt="pager">
          </div>

          <h2>{{$t('addOrder.pagerTitle')}}</h2>
          <input type="text" @keyup.enter="applyPager()" id="pagerInput" ref="pagerInput" v-model="pagerText" :placeholder="$t('addOrder.pagerPlaceholder')" name="pagerInput">
        </div>

        <span>{{$t('addOrder.couponExit')}}</span>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="cuiModal"
            v-model="showCuiModal"
            :hideOverlay="true"
            class="cuiModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="cuiModal__wrapper" @click="closeCuiModal()">

        <!-- <div class="xModalBtn" @click="showPagerModal = false"><span>x</span></div> -->
        <div class="centered_box">
          <!-- <div class="couponModal__img__wrapper">
            <img :src="'../pager.png'" alt="pager">
          </div> -->

          <h2>{{$t('addOrder.cuiPlaceholder')}}</h2>
          <input type="text" @keyup.enter="changeCui()" id="cuiInput" ref="cuiInput" v-model="cuiText" placeholder="CUI" name="cuiInput">
        </div>

        <span>{{$t('addOrder.couponExit')}}</span>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="soldWithModal"
            v-model="showSoldWithModal"
            :hideOverlay="true"
            :class="['soldWithModal', showSoldWithModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="soldWithModal__wrapper">
        <!-- <div class="xModalBtn" @click="showSoldWithModal = false"><span>x</span></div> -->
        <div class="soldWithTopBar">
          <h2>{{$t('addOrder.soldWithTitle')}}</h2>
        </div>
        
        <div class="products__wrapper">
          <template v-for="products in soldWithCategory" v-bind:key="products.id">
            
            <div class="SW_products" v-if="soldWithCategory && soldWithCategory.length > 0">
              <span class="cat_title">{{products.title}}</span>
              <template v-for="prod in products.products" v-bind:key="prod.id">
                <div :class="prod.active ? 'SW_product active' : 'SW_product' " @click="selectSoldWithProduct(prod)">
                  <template v-if="prod.src">
                    <div class="product__photo" :style="['background-image: url(' + encodeURI(prod.src) + ');',
                                prod.image_size ? 'background-size: '+ prod.image_size + ';' : '']">
                    </div>
                    <!-- <div class="productImage" 
                                :style="['background-image: url(' + encodeURI(product.image_url) + ');',
                                product.image_size ? 'background-size: '+ product.image_size + ';' : '']"></div> -->
                  </template>
                  <div class="description">
                    <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                  </div>
                  
                  <div class="product_details">
                    <div class="product_price">
                      <template v-if="prod.use_price_to_show && prod.price_to_show > 0">
                        <span v-html="soldWithProductDisplayPrice(prod).toFixed(2) + ' ' + currency_symbol"></span>
                      </template>
                      <template v-else>
                        <span v-if="prod.price > 0 || soldWithRequiredOptionsPrice(prod) > 0" v-html="soldWithProductDisplayPrice(prod).toFixed(2) + ' ' + currency_symbol"></span>
                      </template>
                    </div>
                  </div>

                </div>
              </template>
            </div>
          </template>
        </div>

        <div class="soldWithBottomBar">
          <!-- <button class="soldWithNoBtn" @click="closeSoldWithPopup()">{{$t('addOrder.soldWithNo')}}</button> -->
          <!-- <div class="addToCart__left"> -->
            <div class="footer__backbtn">
              <button class="backButon" @click="showSoldWithModal = false">
                <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                      <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                    </svg>
                {{$t('addOrder.close')}}
              </button>
            </div>
          <!-- </div> -->

          <div class="soldWithBottomBar__right">
            <button class="soldWith_total_extra"><span>{{$t('addOrder.soldWithExtra')}}</span> <span>{{extraCostSoldWith}}</span></button>
            <button class="soldWithAddBtn" @click="addTOCartExtra()" :disabled="!selectedSoldWithProducts.length">
              <svg xmlns="http://www.w3.org/2000/svg" width="50.942" height="50.933" viewBox="0 0 50.942 50.933">
                <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(1.999 2)">
                  <g id="Bag">
                    <path id="Path_33955" d="M34.286,35.848H12.624C4.667,35.848-1.438,33.144.3,22.26L2.315,7.509C3.384,2.078,7.066,0,10.3,0H36.708c3.278,0,6.746,2.235,7.981,7.509l2.019,14.75C48.181,31.915,42.243,35.848,34.286,35.848Z" transform="translate(0 11.085)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                    <path id="Path_33956" d="M22.47,10.549C22.47,4.723,17.45,0,11.259,0h0A11.582,11.582,0,0,0,3.3,3.074,10.244,10.244,0,0,0,0,10.549H0" transform="translate(12.172 0)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                    <path id="Line_192" d="M.554.458H.435" transform="translate(30.573 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                    <path id="Line_193" d="M.554.458H.435" transform="translate(15.443 21.087)" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4"/>
                  </g>
                </g>
              </svg>
              {{$t('addOrder.soldWithAdd')}}
            </button>
          </div>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="soldWithMenuSuggestionModal"
            v-model="showSoldWithMenuSuggestionModal"
            :hideOverlay="false"
            :class="['soldWithMenuSuggestionModal', showSoldWithMenuSuggestionModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="soldWithMenuSuggestionModal__wrapper">
        <!-- <div class="xModalBtn" @click="showSoldWithMenuSuggestionModal = false"><span>x</span></div> -->
        <div class="soldWithTopBar">
          <h2>{{$t('addOrder.menuCombo')}}</h2>
        </div>
        
        <div class="products__wrapper">
          <!-- <div class="products__wrapper_center"> -->
            <template v-for="products in soldWithCategory" v-bind:key="products.id">
              
              <template v-if="soldWithCategory && soldWithCategory.length > 0">
              <!-- <div class="SW_products" v-if="soldWithCategory && soldWithCategory.length > 0"> -->
                <!-- <span class="cat_title">{{products.title}}</span> -->
                <template v-for="prod in products.products" v-bind:key="prod.id">
                  <div :class="prod.active ? 'SW_product active' : 'SW_product' " @click="openProduct(prod, null, null, null, null, 1)">
                    <template v-if="prod.src">
                      <div class="product__photo" :style="'background-image: url(' + prod.src + ');'">
                      </div>
                    </template>
                    <div class="description">
                      <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                    </div>
                    
                    <div class="product_details">
                      <div class="product_price">
                        <template v-if="prod.use_price_to_show && prod.price_to_show > 0">
                          <span v-html="prod.price_to_show.toFixed(2) + ' ' + currency_symbol"></span>
                        </template>
                        <template v-else>
                          <span v-if="prod.price > 0" v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                        </template>
                      </div>
                    </div>

                  </div>
                </template>
              <!-- </div> -->
              </template>
            </template>
          <!-- </div> -->
        </div>

        <div class="soldWithBottomBar">
            <div class="footer__backbtn" style="width: 100%;">
              <button class="backButon" @click="closeShowSoldWithMenuSuggestionModal" style="font-size: 2.87rem;">
                <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
                      <path id="Icon_ionic-ios-arrow-dropleft-circle" data-name="Icon ionic-ios-arrow-dropleft-circle" d="M26.875,3.375a23.5,23.5,0,1,0,23.5,23.5A23.5,23.5,0,0,0,26.875,3.375Zm4.9,32.663a2.189,2.189,0,0,1,0,3.084,2.154,2.154,0,0,1-1.537.633,2.192,2.192,0,0,1-1.548-.644L18.074,28.457a2.178,2.178,0,0,1,.068-3.005L28.92,14.639A2.181,2.181,0,0,1,32,17.724l-9.253,9.151Z" transform="translate(-3.375 -3.375)" fill="inherit"/>
                    </svg>
                {{$t('addOrder.close')}}
              </button>
            </div>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="iframeModal"
            v-model="showIframeModal"
            :hideOverlay="true"
            class="iframeModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showIframeModal = false, onePaymentAllreadyPicked = false"><span>x</span></div>

        <iframe :src="paymentLinkForIframe" id="paymentFrame" frameborder="0"></iframe>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="settingsModal"
            v-model="showSettingsModal"
            :hideOverlay="true"
            class="settingsModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="closeSettingsModal()"><span>x</span></div>
        <h1>Settings</h1>
        <div class="settings_buttons" v-if="!corectPass">
          <input type="password" v-model="thePass" placeholder="pass">
          <br>
          <button @click="verifyPass()">Enter</button>
        </div>
        <div class="settings_buttons" v-if="corectPass">
          <div class="settings_grid">
            <button @click="getRaport('X')">GET X</button>
            <button @click="getRaport('Z')">GET Z</button>

            <button @click="getHistoryZ()">GET HISTORY Z</button>
            <button @click="getHistoryBon()">GET HISTORY BON</button>

            <button class="settings_grid__full" @click="openSearchOrderModal()">CAUTA COMANDA</button>

            <button @click="hardReload()" :disabled="isPaymentProblemActive()" :class="{ 'settings_grid__disabled': isPaymentProblemActive() }">RELOAD</button>
            <button @click="closeTab()" :disabled="isPaymentProblemActive()" :class="{ 'settings_grid__disabled': isPaymentProblemActive() }">CLOSE</button>

            <button v-if="DBfiscalNet" class="settings_grid__full" @click="bringFiscalNetToFront()">DESCHIDE FISCALNET</button>

            <button
              v-if="blockKioskFiscalError && lastOrderNumberForFiscalError"
              class="settings_grid__full settings_grid__warn"
              @click="reFiscalForOrder(lastOrderNumberForFiscalError)"
            >{{ fiscalErrorCase === 'place_and_fiscal' ? 'Pune comanda si refiscalizeaza' : 'Refiscalizeaza comanda' }}: {{ lastOrderNumberForFiscalError }}</button>

            <template v-if="isUsingCashMachine">
              <button @click="cashMachinePay()">Start Incarcare bani</button>
              <button @click="cashMachineStop()">Stop Incarcare bani</button>
              <button @click="cashMachineEmptyAll()">Goleste Payout in Cash Box</button>
              <button @click="cashMachineGetAmount()">Vezi banii din payout</button>
            </template>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="p9Modal"
            v-model="showP9Modal"
            :hideOverlay="true"
            class="p9Modal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showP9Modal = false; swiperTutorial.slideTo(0)"><span>x</span></div>
        
        <swiper
          :modules="swiperModuleTutorial"
          @swiper="onSwiperTutorial"
          effect="fade"
          scrollbar
          :loop="false"
          :grabCursor="false"
          :centeredSlides="true"
          :autoplay="{
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false
          }"
          class="swipper_tutorial special-offer-block focus-in"
        >
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_logo.png'" alt="p9_tutorial_logo">
              <h1>Bine ai venit la Piața9 Cetate!</h1>
              <h2 style="margin-bottom: 5px;">Dacă ești pentru prima dată te rugăm să iei în considerare câteva aspecte importante</h2>
              <button @click="swiperTutorial.slideTo(1)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s2.png'" alt="p9_tutorial_s2">
              <h2 style="margin-bottom: 0;">Comanda se face direct de la masă:  scanezi codul QR — adaugi produsele în coș — confirmi comanda.</h2>
              <button @click="swiperTutorial.slideTo(2)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s3.png'" alt="payment_tutorial3" style="width: 100%; max-width: 300px;">
              <h2 style="margin-bottom: 0;">Poți plăti direct online, la finalizarea comenzii, folosind Apple Pay, Google Wallet sau cardul bancar.</h2>
              <h2>Te rugăm să urmezi cu atenție toți pașii indicați de platformă și de aplicațiile terțe implicate.</h2>
              <button @click="swiperTutorial.slideTo(3)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s4.png'" alt="payment_tutorial4" style="width: 100%; max-width: 300px;">
              <h1>FOARTE IMPORTANT!</h1>
              <h2 style="margin-bottom: 5px;">Comanda ta este validată doar în momentul în care primești un mesaj clar de confirmare din partea noastră.</h2>
              <button @click="swiperTutorial.slideTo(4)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s5.png'" alt="payment_tutorial5" style="width: 100%; max-width: 300px;">
              <h2 style="margin-bottom: 0;">Ai și opțiunea să plătești cu NUMERAR sau cu CARDUL la POS.</h2>
              <h2>În acest caz, pentru a confirma comanda și a efectua plata, prezintă colegilor de la bar mesajul primit la finalizarea comenzii.</h2>
              <button @click="swiperTutorial.slideTo(5)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_logo.png'" alt="p9_tutorial_logo">
              <h2>Dacă ai orice fel de întrebare sau nelămurire, nu ezita să apelezi la colegii noștri prezenți în locație.</h2>
              <button @click="showP9Modal = false; swiperTutorial.slideTo(0)" class="settings_buttons_btn1">Comandă</button>
            </div>
          </swiper-slide>
        </swiper>

        
      </div>
    </vue-final-modal>

    <div id="swal-template"></div>
  </div>
  <!-- activeKeyboard ? 'activeKeyboard' : 'inactiveKeyboard', -->
  <div :class="[this.showClientModal ? 'keyboard-phone-layout' : '']">
    <div
      :style="`
              --addBtnColor: ${colors.addBtnColor};
              --addBtnColorInv: ${colors.addBtnColorInv}; 
              --iconsColor1: ${colors.iconsColor1}; 
              --iconsColor2: ${colors.iconsColor2}; 
              --secundar: ${colors.secundarColor}; 
              --principal: ${colors.principalColor}; 
              --sideBarBg: ${colors.sideBarBg};
              --mainPageBg: ${colors.mainPageBg};
              --white: ${whiteColor};
            `"
      class="simple-keyboard" v-show="activeKeyboard"></div>
      </div>
</template>


<script>
/* eslint-disable */
import { utilsMixin } from '../mixins/utils.js'
import { sharedFunction } from '../mixins/sharedFunction.js'
import ProductOptionsKiosk from '../components/ProductOptionsKiosk';

import QuantitySelector from '../components/QuantitySelector.vue'

import settingsSvg from './svg/settingsSvg';
import bgBtns from './svg/bgBtns';
import cardSvg from './svg/cardSvg';
import counterSvg from './svg/counterSvg';
import posSvg from './svg/posSvg';
import qrSvg from './svg/qrSvg';
import splashIcons from './svg/splashIcons';
import freeSvg from './svg/freeSvg';
import couponSvg from './svg/couponSvg';
import emptyCartSvg from './svg/emptyCartSvg';
export default {
  mixins: [utilsMixin, sharedFunction],
  name: 'OrderViewKiosk',
  components: {
    QuantitySelector,
    ProductOptionsKiosk,
    settingsSvg,
    bgBtns,
    cardSvg,
    counterSvg,
    posSvg,
    qrSvg,
    splashIcons,
    couponSvg,
    emptyCartSvg,
    freeSvg
  },
  props: {
    msg: String
  },
  data () {
    return {
      // in sharedFunction
      whiteColor: "#fff",
      debounceTouchEnd: null
    }
  },
  mounted() {
    //remove keyboard on click
    let elNotKey = document.querySelector("html");
    elNotKey.addEventListener('touchend', (event) => {
      let keyEl = document.querySelector(".simple-keyboard");
      let langBtnEl = document.querySelector(".lang_btn");
      let langBtnEl2 = document.querySelector(".pack__wrapper .lang_btn");
      if (this.activeKeyboard && !keyEl.contains(event.target) && !this.showClientModal ) {
        this.activeKeyboard = false;
      }
      if (!this.showSplashScreenModal && this.listOfLangIsOpen && !langBtnEl.contains(event.target) ) {
        this.listOfLangIsOpen = false;
      }
      if (this.showSplashScreenModal && this.listOfLangIsOpen && !langBtnEl2.contains(event.target)) {
        this.listOfLangIsOpen = false;
      }
    }, false);

    // handleGesture
    let touchableElement = document.querySelector(".productList");
    if (touchableElement) {
      touchableElement.addEventListener('touchstart', (event) => {
          if (!this.withNoSwipe) return;

          this.touchstartX = event.changedTouches[0].screenX;
          this.touchstartY = event.changedTouches[0].screenY;
          // if(touchableElement.scrollTop + touchableElement.offsetHeight == touchableElement.scrollHeight) {
          if (touchableElement.scrollHeight - touchableElement.offsetHeight <= touchableElement.scrollTop + 2) {
            this.bottomReach = 1
          } else {
            this.bottomReach = 0
          }
          if(touchableElement.scrollTop == 0) {
            this.topReach = 1
          } else {
            this.topReach = 0
          }
      }, false);

      touchableElement.addEventListener('touchend', (event) => {
        clearTimeout(this.debounceTouchEnd);
        this.debounceTouchEnd = setTimeout( () => {
          this.touchendX = event.changedTouches[0].screenX;
          this.touchendY = event.changedTouches[0].screenY;
          this.handleGesture(touchableElement)
        }, 100)
      }, false);

      // scrool effect
      this.setScroolVars(touchableElement, this.activeProductList)
      touchableElement.addEventListener('scroll', (event) => {
          this.setScroolVars(touchableElement, this.activeProductList)
          if (this.activeProductList.bottom == false && this.json.type == 'Kiosk') {
            this.infoShown.bottom = true
          } else {
            this.infoShown.bottom = false
          }
      }, false);
    }

    //disabled contextmenu
    if (!window.is_local) {
      document.addEventListener("contextmenu", function (e) {
          e.preventDefault();
      }, false);
    }

    // scrool effect
    let filterElement = document.querySelector(".filter__cat");
    if (filterElement) {
      this.setScroolVars(filterElement, this.activeFilter)
      filterElement.addEventListener('scroll', (event) => {
        this.setScroolVars(filterElement, this.activeFilter)
      }, false);
    }
  },
  created () {
    this.restart()
  },
  methods: {
    languageFlag (language) {
      return this.langFlagSrc(language)
    },
    // in sharedFunction
    updateQuantityOptions(opId, values, newQuantity) {
      values.quantity = newQuantity;
      this.updateCategories(opId, values.id)
    },
    getTotalOptionLabel (name) {
      switch (name) {
        case 'Loyalty_Points_Discount':
          return this.$t('general.loyaltyPoints');

        case 'Tip':
          return this.$t('general.tip');

        default:
          return name;
      }
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "./scss/OrderViewKiosk.scss";
</style>
